! function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).Motion = {})
}(this, (function(t) {
    "use strict";

    function e(t, e) {
        -1 === t.indexOf(e) && t.push(e)
    }

    function i(t, e) {
        const i = t.indexOf(e);
        i > -1 && t.splice(i, 1)
    }
    const n = (t, e, i) => Math.min(Math.max(i, t), e),
        s = {
            duration: .3,
            delay: 0,
            endDelay: 0,
            repeat: 0,
            easing: "ease"
        },
        o = t => "number" == typeof t,
        r = t => Array.isArray(t) && !o(t[0]);

    function l(t, e) {
        return r(t) ? t[((t, e, i) => {
            const n = e - 0;
            return ((i - 0) % n + n) % n + 0
        })(0, t.length, e)] : t
    }
    const a = (t, e, i) => -i * t + i * e + t,
        h = () => {},
        c = t => t,
        d = (t, e, i) => e - t == 0 ? 1 : (i - t) / (e - t);

    function u(t, e) {
        const i = t[t.length - 1];
        for (let n = 1; n <= e; n++) {
            const s = d(0, e, n);
            t.push(a(i, 1, s))
        }
    }

    function p(t) {
        const e = [0];
        return u(e, t - 1), e
    }

    function f(t, e = p(t.length), i = c) {
        const s = t.length,
            o = s - e.length;
        return o > 0 && u(e, o), o => {
            let r = 0;
            for (; r < s - 2 && !(o < e[r + 1]); r++);
            let h = n(0, 1, d(e[r], e[r + 1], o));
            return h = l(i, r)(h), a(t[r], t[r + 1], h)
        }
    }
    const g = t => Array.isArray(t) && o(t[0]),
        m = t => "object" == typeof t && Boolean(t.createAnimation),
        y = t => "function" == typeof t,
        v = t => "string" == typeof t,
        w = t => 1e3 * t,
        b = t => t / 1e3;

    function S(t, e) {
        return e ? t * (1e3 / e) : 0
    }
    const E = (t, e, i) => (((1 - 3 * i + 3 * e) * t + (3 * i - 6 * e)) * t + 3 * e) * t;

    function x(t, e, i, n) {
        if (t === e && i === n) return c;
        const s = e => function(t, e, i, n, s) {
            let o, r, l = 0;
            do {
                r = e + (i - e) / 2, o = E(r, n, s) - t, o > 0 ? i = r : e = r
            } while (Math.abs(o) > 1e-7 && ++l < 12);
            return r
        }(e, 0, 1, t, i);
        return t => 0 === t || 1 === t ? t : E(s(t), e, n)
    }
    const C = {
            ease: x(.25, .1, .25, 1),
            "ease-in": x(.42, 0, 1, 1),
            "ease-in-out": x(.42, 0, .58, 1),
            "ease-out": x(0, 0, .58, 1)
        },
        D = /\((.*?)\)/;

    function A(t) {
        if (y(t)) return t;
        if (g(t)) return x(...t);
        if (C[t]) return C[t];
        if (t.startsWith("steps")) {
            const e = D.exec(t);
            if (e) {
                const t = e[1].split(",");
                return ((t, e = "end") => i => {
                    const s = (i = "end" === e ? Math.min(i, .999) : Math.max(i, .001)) * t,
                        o = "end" === e ? Math.floor(s) : Math.ceil(s);
                    return n(0, 1, o / t)
                })(parseFloat(t[0]), t[1].trim())
            }
        }
        return c
    }
    class P {
        constructor(t, e = [0, 1], {
            easing: i,
            duration: n = s.duration,
            delay: o = s.delay,
            endDelay: l = s.endDelay,
            repeat: a = s.repeat,
            offset: h,
            direction: d = "normal"
        } = {}) {
            if (this.startTime = null, this.rate = 1, this.t = 0, this.cancelTimestamp = null, this.easing = c, this.duration = 0, this.totalDuration = 0, this.repeat = 0, this.playState = "idle", this.finished = new Promise(((t, e) => {
                    this.resolve = t, this.reject = e
                })), i = i || s.easing, m(i)) {
                const t = i.createAnimation(e);
                i = t.easing, e = t.keyframes || e, n = t.duration || n
            }
            this.repeat = a, this.easing = r(i) ? c : A(i), this.updateDuration(n);
            const u = f(e, h, r(i) ? i.map(A) : c);
            this.tick = e => {
                var i;
                let n = 0;
                n = void 0 !== this.pauseTime ? this.pauseTime : (e - this.startTime) * this.rate, this.t = n, n /= 1e3, n = Math.max(n - o, 0), "finished" === this.playState && void 0 === this.pauseTime && (n = this.totalDuration);
                const s = n / this.duration;
                let r = Math.floor(s),
                    a = s % 1;
                !a && s >= 1 && (a = 1), 1 === a && r--;
                const h = r % 2;
                ("reverse" === d || "alternate" === d && h || "alternate-reverse" === d && !h) && (a = 1 - a);
                const c = n >= this.totalDuration ? 1 : Math.min(a, 1),
                    p = u(this.easing(c));
                t(p), void 0 === this.pauseTime && ("finished" === this.playState || n >= this.totalDuration + l) ? (this.playState = "finished", null === (i = this.resolve) || void 0 === i || i.call(this, p)) : "idle" !== this.playState && (this.frameRequestId = requestAnimationFrame(this.tick))
            }, this.play()
        }
        play() {
            const t = performance.now();
            this.playState = "running", void 0 !== this.pauseTime ? this.startTime = t - this.pauseTime : this.startTime || (this.startTime = t), this.cancelTimestamp = this.startTime, this.pauseTime = void 0, this.frameRequestId = requestAnimationFrame(this.tick)
        }
        pause() {
            this.playState = "paused", this.pauseTime = this.t
        }
        finish() {
            this.playState = "finished", this.tick(0)
        }
        stop() {
            var t;
            this.playState = "idle", void 0 !== this.frameRequestId && cancelAnimationFrame(this.frameRequestId), null === (t = this.reject) || void 0 === t || t.call(this, !1)
        }
        cancel() {
            this.stop(), this.tick(this.cancelTimestamp)
        }
        reverse() {
            this.rate *= -1
        }
        commitStyles() {}
        updateDuration(t) {
            this.duration = t, this.totalDuration = t * (this.repeat + 1)
        }
        get currentTime() {
            return this.t
        }
        set currentTime(t) {
            void 0 !== this.pauseTime || 0 === this.rate ? this.pauseTime = t : this.startTime = performance.now() - t / this.rate
        }
        get playbackRate() {
            return this.rate
        }
        set playbackRate(t) {
            this.rate = t
        }
    }
    class L {
        setAnimation(t) {
            this.animation = t, null == t || t.finished.then((() => this.clearAnimation())).catch((() => {}))
        }
        clearAnimation() {
            this.animation = this.generator = void 0
        }
    }
    const M = new WeakMap;

    function I(t) {
        return M.has(t) || M.set(t, {
            transforms: [],
            values: new Map
        }), M.get(t)
    }
    const z = ["", "X", "Y", "Z"],
        k = {
            x: "translateX",
            y: "translateY",
            z: "translateZ"
        },
        T = {
            syntax: "<angle>",
            initialValue: "0deg",
            toDefaultUnit: t => t + "deg"
        },
        W = {
            translate: {
                syntax: "<length-percentage>",
                initialValue: "0px",
                toDefaultUnit: t => t + "px"
            },
            rotate: T,
            scale: {
                syntax: "<number>",
                initialValue: 1,
                toDefaultUnit: c
            },
            skew: T
        },
        O = new Map,
        F = t => `--motion-${t}`,
        _ = ["x", "y", "z"];
    ["translate", "scale", "rotate", "skew"].forEach((t => {
        z.forEach((e => {
            _.push(t + e), O.set(F(t + e), W[t])
        }))
    }));
    const N = (t, e) => _.indexOf(t) - _.indexOf(e),
        j = new Set(_),
        B = t => j.has(t),
        $ = t => t.sort(N).reduce(H, "").trim(),
        H = (t, e) => `${t} ${e}(var(${F(e)}))`,
        q = t => t.startsWith("--"),
        R = new Set,
        U = (t, e) => document.createElement("div").animate(t, e),
        V = {
            cssRegisterProperty: () => "undefined" != typeof CSS && Object.hasOwnProperty.call(CSS, "registerProperty"),
            waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
            partialKeyframes: () => {
                try {
                    U({
                        opacity: [1]
                    })
                } catch (t) {
                    return !1
                }
                return !0
            },
            finished: () => Boolean(U({
                opacity: [0, 1]
            }, {
                duration: .001
            }).finished),
            linearEasing: () => {
                try {
                    U({
                        opacity: 0
                    }, {
                        easing: "linear(0, 1)"
                    })
                } catch (t) {
                    return !1
                }
                return !0
            }
        },
        X = {},
        G = {};
    for (const t in V) G[t] = () => (void 0 === X[t] && (X[t] = V[t]()), X[t]);
    const Y = (t, e) => y(t) ? G.linearEasing() ? `linear(${((t,e)=>{let i="";const n=Math.round(e/.015);for(let e=0;e<n;e++)i+=t(d(0,n-1,e))+", ";return i.substring(0,i.length-2)})(t,e)})` : s.easing : g(t) ? Z(t) : t,
        Z = ([t, e, i, n]) => `cubic-bezier(${t}, ${e}, ${i}, ${n})`,
        K = t => Array.isArray(t) ? t : [t];

    function Q(t) {
        return k[t] && (t = k[t]), B(t) ? F(t) : t
    }
    const J = {
        get: (t, e) => {
            e = Q(e);
            let i = q(e) ? t.style.getPropertyValue(e) : getComputedStyle(t)[e];
            if (!i && 0 !== i) {
                const t = O.get(e);
                t && (i = t.initialValue)
            }
            return i
        },
        set: (t, e, i) => {
            e = Q(e), q(e) ? t.style.setProperty(e, i) : t.style[e] = i
        }
    };

    function tt(t, e = !0) {
        if (t && "finished" !== t.playState) try {
            t.stop ? t.stop() : (e && t.commitStyles(), t.cancel())
        } catch (t) {}
    }

    function et(t, e) {
        var i;
        let n = (null == e ? void 0 : e.toDefaultUnit) || c;
        const s = t[t.length - 1];
        if (v(s)) {
            const t = (null === (i = s.match(/(-?[\d.]+)([a-z%]*)/)) || void 0 === i ? void 0 : i[2]) || "";
            t && (n = e => e + t)
        }
        return n
    }

    function it(t, i, n, l = {}, a) {
        const c = window.__MOTION_DEV_TOOLS_RECORD,
            d = !1 !== l.record && c;
        let u, {
            duration: p = s.duration,
            delay: f = s.delay,
            endDelay: g = s.endDelay,
            repeat: v = s.repeat,
            easing: b = s.easing,
            persist: S = !1,
            direction: E,
            offset: x,
            allowWebkitAcceleration: C = !1
        } = l;
        const D = I(t),
            A = B(i);
        let P = G.waapi();
        A && ((t, i) => {
            k[i] && (i = k[i]);
            const {
                transforms: n
            } = I(t);
            e(n, i), t.style.transform = $(n)
        })(t, i);
        const M = Q(i),
            z = function(t, e) {
                return t.has(e) || t.set(e, new L), t.get(e)
            }(D.values, M),
            T = O.get(M);
        return tt(z.animation, !(m(b) && z.generator) && !1 !== l.record), () => {
            const e = () => {
                var e, i;
                return null !== (i = null !== (e = J.get(t, M)) && void 0 !== e ? e : null == T ? void 0 : T.initialValue) && void 0 !== i ? i : 0
            };
            let s = function(t, e) {
                for (let i = 0; i < t.length; i++) null === t[i] && (t[i] = i ? t[i - 1] : e());
                return t
            }(K(n), e);
            const D = et(s, T);
            if (m(b)) {
                const t = b.createAnimation(s, "opacity" !== i, e, M, z);
                b = t.easing, s = t.keyframes || s, p = t.duration || p
            }
            if (q(M) && (G.cssRegisterProperty() ? function(t) {
                    if (!R.has(t)) {
                        R.add(t);
                        try {
                            const {
                                syntax: e,
                                initialValue: i
                            } = O.has(t) ? O.get(t) : {};
                            CSS.registerProperty({
                                name: t,
                                inherits: !1,
                                syntax: e,
                                initialValue: i
                            })
                        } catch (t) {}
                    }
                }(M) : P = !1), A && !G.linearEasing() && (y(b) || r(b) && b.some(y)) && (P = !1), P) {
                T && (s = s.map((t => o(t) ? T.toDefaultUnit(t) : t))), 1 !== s.length || G.partialKeyframes() && !d || s.unshift(e());
                const i = {
                    delay: w(f),
                    duration: w(p),
                    endDelay: w(g),
                    easing: r(b) ? void 0 : Y(b, p),
                    direction: E,
                    iterations: v + 1,
                    fill: "both"
                };
                u = t.animate({
                    [M]: s,
                    offset: x,
                    easing: r(b) ? b.map((t => Y(t, p))) : void 0
                }, i), u.finished || (u.finished = new Promise(((t, e) => {
                    u.onfinish = t, u.oncancel = e
                })));
                const n = s[s.length - 1];
                u.finished.then((() => {
                    S || (J.set(t, M, n), u.cancel())
                })).catch(h), C || (u.playbackRate = 1.000001)
            } else if (a && A) s = s.map((t => "string" == typeof t ? parseFloat(t) : t)), 1 === s.length && s.unshift(parseFloat(e())), u = new a((e => {
                J.set(t, M, D ? D(e) : e)
            }), s, Object.assign(Object.assign({}, l), {
                duration: p,
                easing: b
            }));
            else {
                const e = s[s.length - 1];
                J.set(t, M, T && o(e) ? T.toDefaultUnit(e) : e)
            }
            return d && c(t, i, s, {
                duration: p,
                delay: f,
                easing: b,
                repeat: v,
                offset: x
            }, "motion-one"), z.setAnimation(u), u
        }
    }
    const nt = (t, e) => t[e] ? Object.assign(Object.assign({}, t), t[e]) : Object.assign({}, t);

    function st(t, e) {
        var i;
        return "string" == typeof t ? e ? (null !== (i = e[t]) && void 0 !== i || (e[t] = document.querySelectorAll(t)), t = e[t]) : t = document.querySelectorAll(t) : t instanceof Element && (t = [t]), Array.from(t || [])
    }
    const ot = t => t(),
        rt = (t, e, i = s.duration) => new Proxy({
            animations: t.map(ot).filter(Boolean),
            duration: i,
            options: e
        }, lt),
        lt = {
            get: (t, e) => {
                const i = t.animations[0];
                switch (e) {
                    case "duration":
                        return t.duration;
                    case "currentTime":
                        return b((null == i ? void 0 : i[e]) || 0);
                    case "playbackRate":
                    case "playState":
                        return null == i ? void 0 : i[e];
                    case "finished":
                        return t.finished || (t.finished = Promise.all(t.animations.map(at)).catch(h)), t.finished;
                    case "stop":
                        return () => {
                            t.animations.forEach((t => tt(t)))
                        };
                    case "forEachNative":
                        return e => {
                            t.animations.forEach((i => e(i, t)))
                        };
                    default:
                        return void 0 === (null == i ? void 0 : i[e]) ? void 0 : () => t.animations.forEach((t => t[e]()))
                }
            },
            set: (t, e, i) => {
                switch (e) {
                    case "currentTime":
                        i = w(i);
                    case "currentTime":
                    case "playbackRate":
                        for (let n = 0; n < t.animations.length; n++) t.animations[n][e] = i;
                        return !0
                }
                return !1
            }
        },
        at = t => t.finished;

    function ht(t, e, i) {
        return y(t) ? t(e, i) : t
    }

    function ct(t) {
        return function(e, i, n = {}) {
            const s = (e = st(e)).length,
                o = [];
            for (let r = 0; r < s; r++) {
                const l = e[r];
                for (const e in i) {
                    const a = nt(n, e);
                    a.delay = ht(a.delay, r, s);
                    const h = it(l, e, i[e], a, t);
                    o.push(h)
                }
            }
            return rt(o, n, n.duration)
        }
    }
    const dt = ct(P);

    function ut(t, e) {
        var i = {};
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var s = 0;
            for (n = Object.getOwnPropertySymbols(t); s < n.length; s++) e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]])
        }
        return i
    }

    function pt(t, e, i, n) {
        var s;
        return o(e) ? e : e.startsWith("-") || e.startsWith("+") ? Math.max(0, t + parseFloat(e)) : "<" === e ? i : null !== (s = n.get(e)) && void 0 !== s ? s : t
    }

    function ft(t, e, n, s, o, r) {
        ! function(t, e, n) {
            for (let s = 0; s < t.length; s++) {
                const o = t[s];
                o.at > e && o.at < n && (i(t, o), s--)
            }
        }(t, o, r);
        for (let i = 0; i < e.length; i++) t.push({
            value: e[i],
            at: a(o, r, s[i]),
            easing: l(n, i)
        })
    }

    function gt(t, e) {
        return t.at === e.at ? null === t.value ? 1 : -1 : t.at - e.at
    }

    function mt(t, e) {
        return !e.has(t) && e.set(t, {}), e.get(t)
    }

    function yt(t, e) {
        return e[t] || (e[t] = []), e[t]
    }

    function vt(t, e, i) {
        const n = Math.max(e - 5, 0);
        return S(i - t(n), e - n)
    }
    const wt = ({
        stiffness: t = 100,
        damping: e = 10,
        mass: i = 1,
        from: n = 0,
        to: s = 1,
        velocity: o = 0,
        restSpeed: r = 2,
        restDistance: l = .5
    } = {}) => {
        o = o ? b(o) : 0;
        const a = {
                done: !1,
                hasReachedTarget: !1,
                current: n,
                target: s
            },
            h = s - n,
            c = Math.sqrt(t / i) / 1e3,
            d = ((t = 100, e = 10, i = 1) => e / (2 * Math.sqrt(t * i)))(t, e, i);
        let u;
        if (d < 1) {
            const t = c * Math.sqrt(1 - d * d);
            u = e => s - Math.exp(-d * c * e) * ((d * c * h - o) / t * Math.sin(t * e) + h * Math.cos(t * e))
        } else u = t => s - Math.exp(-c * t) * (h + (c * h - o) * t);
        return t => {
            a.current = u(t);
            const e = 0 === t ? o : vt(u, t, a.current),
                i = Math.abs(e) <= r,
                h = Math.abs(s - a.current) <= l;
            var c, d, p;
            return a.done = i && h, a.hasReachedTarget = (c = n, d = s, p = a.current, c < d && p >= d || c > d && p <= d), a
        }
    };

    function bt(t) {
        return o(t) && !isNaN(t)
    }

    function St(t) {
        return v(t) ? parseFloat(t) : t
    }

    function Et(t) {
        const e = new WeakMap;
        return (i = {}) => {
            const n = new Map,
                s = (e = 0, s = 100, o = 0, r = !1) => {
                    const l = `${e}-${s}-${o}-${r}`;
                    return n.has(l) || n.set(l, t(Object.assign({
                        from: e,
                        to: s,
                        velocity: o,
                        restSpeed: r ? .05 : 2,
                        restDistance: r ? .01 : .5
                    }, i))), n.get(l)
                },
                o = (t, i) => (e.has(t) || e.set(t, function(t, e = c) {
                    let i, n = 10,
                        s = t(0);
                    const o = [e(s.current)];
                    for (; !s.done && n < 1e4;) s = t(n), o.push(e(s.done ? s.target : s.current)), void 0 === i && s.hasReachedTarget && (i = n), n += 10;
                    const r = n - 10;
                    return 1 === o.length && o.push(s.current), {
                        keyframes: o,
                        duration: r / 1e3,
                        overshootDuration: (null != i ? i : r) / 1e3
                    }
                }(t, i)), e.get(t));
            return {
                createAnimation: (t, e = !0, i, n, r) => {
                    let l, a, h, d = 0,
                        u = c;
                    const p = t.length;
                    if (e)
                        if (u = et(t, n ? O.get(Q(n)) : void 0), h = St(t[p - 1]), p > 1 && null !== t[0]) a = St(t[0]);
                        else {
                            const t = null == r ? void 0 : r.generator;
                            if (t) {
                                const {
                                    animation: e,
                                    generatorStartTime: i
                                } = r, n = (null == e ? void 0 : e.startTime) || i || 0, s = (null == e ? void 0 : e.currentTime) || performance.now() - n, o = t(s).current;
                                a = o, d = vt((e => t(e).current), s, o)
                            } else i && (a = St(i()))
                        } if (bt(a) && bt(h)) {
                        const t = s(a, h, d, null == n ? void 0 : n.includes("scale"));
                        l = Object.assign(Object.assign({}, o(t, u)), {
                            easing: "linear"
                        }), r && (r.generator = t, r.generatorStartTime = performance.now())
                    }
                    return l || (l = {
                        easing: "ease",
                        duration: o(s(0, 100)).overshootDuration
                    }), l
                }
            }
        }
    }
    const xt = Et(wt),
        Ct = Et((({
            from: t = 0,
            velocity: e = 0,
            power: i = .8,
            decay: n = .325,
            bounceDamping: s,
            bounceStiffness: o,
            changeTarget: r,
            min: l,
            max: a,
            restDistance: h = .5,
            restSpeed: c
        }) => {
            n = w(n);
            const d = {
                    hasReachedTarget: !1,
                    done: !1,
                    current: t,
                    target: t
                },
                u = t => void 0 === l ? a : void 0 === a || Math.abs(l - t) < Math.abs(a - t) ? l : a;
            let p = i * e;
            const f = t + p,
                g = void 0 === r ? f : r(f);
            d.target = g, g !== f && (p = g - t);
            const m = t => -p * Math.exp(-t / n),
                y = t => g + m(t),
                v = t => {
                    const e = m(t),
                        i = y(t);
                    d.done = Math.abs(e) <= h, d.current = d.done ? g : i
                };
            let b, S;
            const E = t => {
                var e;
                e = d.current, (void 0 !== l && e < l || void 0 !== a && e > a) && (b = t, S = wt({
                    from: d.current,
                    to: u(d.current),
                    velocity: vt(y, t, d.current),
                    damping: s,
                    stiffness: o,
                    restDistance: h,
                    restSpeed: c
                }))
            };
            return E(0), t => {
                let e = !1;
                return S || void 0 !== b || (e = !0, v(t), E(t)), void 0 !== b && t > b ? (d.hasReachedTarget = !0, S(t - b)) : (d.hasReachedTarget = !1, !e && v(t), d)
            }
        })),
        Dt = {
            any: 0,
            all: 1
        };

    function At(t, e, {
        root: i,
        margin: n,
        amount: s = "any"
    } = {}) {
        if ("undefined" == typeof IntersectionObserver) return () => {};
        const o = st(t),
            r = new WeakMap,
            l = new IntersectionObserver((t => {
                t.forEach((t => {
                    const i = r.get(t.target);
                    if (t.isIntersecting !== Boolean(i))
                        if (t.isIntersecting) {
                            const i = e(t);
                            y(i) ? r.set(t.target, i) : l.unobserve(t.target)
                        } else i && (i(t), r.delete(t.target))
                }))
            }), {
                root: i,
                rootMargin: n,
                threshold: "number" == typeof s ? s : Dt[s]
            });
        return o.forEach((t => l.observe(t))), () => l.disconnect()
    }
    const Pt = new WeakMap;
    let Lt;

    function Mt({
        target: t,
        contentRect: e,
        borderBoxSize: i
    }) {
        var n;
        null === (n = Pt.get(t)) || void 0 === n || n.forEach((n => {
            n({
                target: t,
                contentSize: e,
                get size() {
                    return function(t, e) {
                        if (e) {
                            const {
                                inlineSize: t,
                                blockSize: i
                            } = e[0];
                            return {
                                width: t,
                                height: i
                            }
                        }
                        return t instanceof SVGElement && "getBBox" in t ? t.getBBox() : {
                            width: t.offsetWidth,
                            height: t.offsetHeight
                        }
                    }(t, i)
                }
            })
        }))
    }

    function It(t) {
        t.forEach(Mt)
    }
    const zt = new Set;
    let kt;

    function Tt(t, e) {
        return y(t) ? function(t) {
            return zt.add(t), kt || (kt = () => {
                const t = {
                        width: window.innerWidth,
                        height: window.innerHeight
                    },
                    e = {
                        target: window,
                        size: t,
                        contentSize: t
                    };
                zt.forEach((t => t(e)))
            }, window.addEventListener("resize", kt)), () => {
                zt.delete(t), !zt.size && kt && (kt = void 0)
            }
        }(t) : function(t, e) {
            Lt || "undefined" != typeof ResizeObserver && (Lt = new ResizeObserver(It));
            const i = st(t);
            return i.forEach((t => {
                let i = Pt.get(t);
                i || (i = new Set, Pt.set(t, i)), i.add(e), null == Lt || Lt.observe(t)
            })), () => {
                i.forEach((t => {
                    const i = Pt.get(t);
                    null == i || i.delete(e), (null == i ? void 0 : i.size) || null == Lt || Lt.unobserve(t)
                }))
            }
        }(t, e)
    }
    const Wt = {
        x: {
            length: "Width",
            position: "Left"
        },
        y: {
            length: "Height",
            position: "Top"
        }
    };

    function Ot(t, e, i, n) {
        const s = i[e],
            {
                length: o,
                position: r
            } = Wt[e],
            l = s.current,
            a = i.time;
        s.current = t["scroll" + r], s.scrollLength = t["scroll" + o] - t["client" + o], s.offset.length = 0, s.offset[0] = 0, s.offset[1] = s.scrollLength, s.progress = d(0, s.scrollLength, s.current);
        const h = n - a;
        s.velocity = h > 50 ? 0 : S(s.current - l, h)
    }
    const Ft = {
            Enter: [
                [0, 1],
                [1, 1]
            ],
            Exit: [
                [0, 0],
                [1, 0]
            ],
            Any: [
                [1, 0],
                [0, 1]
            ],
            All: [
                [0, 0],
                [1, 1]
            ]
        },
        _t = {
            start: 0,
            center: .5,
            end: 1
        };

    function Nt(t, e, i = 0) {
        let n = 0;
        if (void 0 !== _t[t] && (t = _t[t]), v(t)) {
            const e = parseFloat(t);
            t.endsWith("px") ? n = e : t.endsWith("%") ? t = e / 100 : t.endsWith("vw") ? n = e / 100 * document.documentElement.clientWidth : t.endsWith("vh") ? n = e / 100 * document.documentElement.clientHeight : t = e
        }
        return o(t) && (n = e * t), i + n
    }
    const jt = [0, 0];

    function Bt(t, e, i, n) {
        let s = Array.isArray(t) ? t : jt,
            r = 0,
            l = 0;
        return o(t) ? s = [t, t] : v(t) && (s = (t = t.trim()).includes(" ") ? t.split(" ") : [t, _t[t] ? t : "0"]), r = Nt(s[0], i, n), l = Nt(s[1], e), r - l
    }
    const $t = {
        x: 0,
        y: 0
    };

    function Ht(t, e, i, n = {}) {
        const s = n.axis || "y";
        return {
            measure: () => function(t, e = t, i) {
                if (i.x.targetOffset = 0, i.y.targetOffset = 0, e !== t) {
                    let n = e;
                    for (; n && n != t;) i.x.targetOffset += n.offsetLeft, i.y.targetOffset += n.offsetTop, n = n.offsetParent
                }
                i.x.targetLength = e === t ? e.scrollWidth : e.clientWidth, i.y.targetLength = e === t ? e.scrollHeight : e.clientHeight, i.x.containerLength = t.clientWidth, i.y.containerLength = t.clientHeight
            }(t, n.target, i),
            update: e => {
                ! function(t, e, i) {
                    Ot(t, "x", e, i), Ot(t, "y", e, i), e.time = i
                }(t, i, e), (n.offset || n.target) && function(t, e, i) {
                    let {
                        offset: n = Ft.All
                    } = i;
                    const {
                        target: s = t,
                        axis: o = "y"
                    } = i, r = "y" === o ? "height" : "width", l = s !== t ? function(t, e) {
                        let i = {
                                x: 0,
                                y: 0
                            },
                            n = t;
                        for (; n && n !== e;)
                            if (n instanceof HTMLElement) i.x += n.offsetLeft, i.y += n.offsetTop, n = n.offsetParent;
                            else if (n instanceof SVGGraphicsElement && "getBBox" in n) {
                            const {
                                top: t,
                                left: e
                            } = n.getBBox();
                            for (i.x += e, i.y += t; n && "svg" !== n.tagName;) n = n.parentNode
                        }
                        return i
                    }(s, t) : $t, a = s === t ? {
                        width: t.scrollWidth,
                        height: t.scrollHeight
                    } : {
                        width: s.clientWidth,
                        height: s.clientHeight
                    }, h = {
                        width: t.clientWidth,
                        height: t.clientHeight
                    };
                    e[o].offset.length = 0;
                    let c = !e[o].interpolate;
                    const d = n.length;
                    for (let t = 0; t < d; t++) {
                        const i = Bt(n[t], h[r], a[r], l[o]);
                        c || i === e[o].interpolatorOffsets[t] || (c = !0), e[o].offset[t] = i
                    }
                    c && (e[o].interpolate = f(p(d), e[o].offset), e[o].interpolatorOffsets = [...e[o].offset]), e[o].progress = e[o].interpolate(e[o].current)
                }(t, i, n)
            },
            notify: y(e) ? () => e(i) : qt(e, i[s])
        }
    }

    function qt(t, e) {
        return t.pause(), t.forEachNative(((t, {
            easing: e
        }) => {
            var i, n;
            if (t.updateDuration) e || (t.easing = c), t.updateDuration(1);
            else {
                const s = {
                    duration: 1e3
                };
                e || (s.easing = "linear"), null === (n = null === (i = t.effect) || void 0 === i ? void 0 : i.updateTiming) || void 0 === n || n.call(i, s)
            }
        })), () => {
            t.currentTime = e.progress
        }
    }
    const Rt = new WeakMap,
        Ut = new WeakMap,
        Vt = new WeakMap,
        Xt = t => t === document.documentElement ? window : t;

    function Gt(t, e) {
        return function(t) {
            return "object" == typeof t
        }(t) ? t : t && e ? e[t] : void 0
    }
    let Yt;

    function Zt() {
        if (!Yt) return;
        const t = Yt.sort(Qt).map(Jt);
        t.forEach(te), t.forEach(te), Yt = void 0
    }

    function Kt(t) {
        Yt ? e(Yt, t) : (Yt = [t], requestAnimationFrame(Zt))
    }
    const Qt = (t, e) => t.getDepth() - e.getDepth(),
        Jt = t => t.animateUpdates(),
        te = t => t.next(),
        ee = (t, e) => new CustomEvent(t, {
            detail: {
                target: e
            }
        });

    function ie(t, e, i) {
        t.dispatchEvent(new CustomEvent(e, {
            detail: {
                originalEvent: i
            }
        }))
    }

    function ne(t, e, i) {
        t.dispatchEvent(new CustomEvent(e, {
            detail: {
                originalEntry: i
            }
        }))
    }
    const se = (t, e, i) => n => {
            n.pointerType && "mouse" !== n.pointerType || (i(), ie(t, e, n))
        },
        oe = {
            inView: {
                isActive: t => Boolean(t.inView),
                subscribe: (t, {
                    enable: e,
                    disable: i
                }, {
                    inViewOptions: n = {}
                }) => {
                    const {
                        once: s
                    } = n, o = ut(n, ["once"]);
                    return At(t, (n => {
                        if (e(), ne(t, "viewenter", n), !s) return e => {
                            i(), ne(t, "viewleave", e)
                        }
                    }), o)
                }
            },
            hover: {
                isActive: t => Boolean(t.hover),
                subscribe: (t, {
                    enable: e,
                    disable: i
                }) => {
                    const n = se(t, "hoverstart", e),
                        s = se(t, "hoverend", i);
                    return t.addEventListener("pointerenter", n), t.addEventListener("pointerleave", s), () => {
                        t.removeEventListener("pointerenter", n), t.removeEventListener("pointerleave", s)
                    }
                }
            },
            press: {
                isActive: t => Boolean(t.press),
                subscribe: (t, {
                    enable: e,
                    disable: i
                }) => {
                    const n = e => {
                            i(), ie(t, "pressend", e), window.removeEventListener("pointerup", n)
                        },
                        s = i => {
                            e(), ie(t, "pressstart", i), window.addEventListener("pointerup", n)
                        };
                    return t.addEventListener("pointerdown", s), () => {
                        t.removeEventListener("pointerdown", s), window.removeEventListener("pointerup", n)
                    }
                }
            }
        },
        re = ["initial", "animate", ...Object.keys(oe), "exit"],
        le = new WeakMap;

    function ae(t) {
        const e = {},
            i = [];
        for (let n in t) {
            const s = t[n];
            B(n) && (k[n] && (n = k[n]), i.push(n), n = F(n));
            let r = Array.isArray(s) ? s[0] : s;
            const l = O.get(n);
            l && (r = o(s) ? l.toDefaultUnit(s) : s), e[n] = r
        }
        return i.length && (e.transform = $(i)), e
    }
    const he = t => `-${t.toLowerCase()}`;

    function ce(t, e = {}) {
        return rt([() => {
            const i = new P(t, [0, 1], e);
            return i.finished.catch((() => {})), i
        }], e, e.duration)
    }
    t.MotionValue = L, t.ScrollOffset = Ft, t.animate = function(t, e, i) {
        return (y(t) ? ce : dt)(t, e, i)
    }, t.animateStyle = it, t.createAnimate = ct, t.createMotionState = function(t = {}, e) {
        let n, s = e ? e.getDepth() + 1 : 0;
        const o = {
                initial: !0,
                animate: !0
            },
            r = {},
            l = {};
        for (const i of re) l[i] = "string" == typeof t[i] ? t[i] : null == e ? void 0 : e.getContext()[i];
        const a = !1 === t.initial ? "animate" : "initial";
        let c = ut(Gt(t[a] || l[a], t.variants) || {}, ["transition"]);
        const d = Object.assign({}, c),
            u = (t, e) => () => {
                o[t] = e, Kt(f)
            },
            p = () => {
                for (const e in oe) {
                    const i = oe[e].isActive(t),
                        s = r[e];
                    i && !s ? r[e] = oe[e].subscribe(n, {
                        enable: u(e, !0),
                        disable: u(e, !1)
                    }, t) : !i && s && (s(), delete r[e])
                }
            },
            f = {
                update: e => {
                    n && (t = e, p(), Kt(f))
                },
                setActive: (t, e) => {
                    n && (o[t] = e, Kt(f))
                },
                animateUpdates: function*() {
                    var e, i;
                    const s = c;
                    c = {};
                    const r = {};
                    for (const n of re) {
                        if (!o[n]) continue;
                        const s = Gt(t[n]);
                        if (s)
                            for (const n in s) "transition" !== n && (c[n] = s[n], r[n] = nt(null !== (i = null !== (e = s.transition) && void 0 !== e ? e : t.transition) && void 0 !== i ? i : {}, n))
                    }
                    const l = new Set([...Object.keys(c), ...Object.keys(s)]),
                        a = [];
                    l.forEach((t => {
                        var e, i, o;
                        void 0 === c[t] && (c[t] = d[t]), typeof(i = s[t]) == typeof(o = c[t]) && (Array.isArray(i) && Array.isArray(o) ? function(t, e) {
                            const i = e.length;
                            if (i !== t.length) return !1;
                            for (let n = 0; n < i; n++)
                                if (e[n] !== t[n]) return !1;
                            return !0
                        }(i, o) : i === o) || (null !== (e = d[t]) && void 0 !== e || (d[t] = J.get(n, t)), a.push(it(n, t, c[t], r[t], P)))
                    })), yield;
                    const u = a.map((t => t())).filter(Boolean);
                    if (!u.length) return;
                    const p = c;
                    n.dispatchEvent(ee("motionstart", p)), Promise.all(u.map((t => t.finished))).then((() => {
                        n.dispatchEvent(ee("motioncomplete", p))
                    })).catch(h)
                },
                getDepth: () => s,
                getTarget: () => c,
                getOptions: () => t,
                getContext: () => l,
                mount: t => (n = t, le.set(n, f), p(), () => {
                    le.delete(n),
                        function(t) {
                            Yt && i(Yt, t)
                        }(f);
                    for (const t in r) r[t]()
                }),
                isMounted: () => Boolean(n)
            };
        return f
    }, t.createStyleString = function(t = {}) {
        const e = ae(t);
        let i = "";
        for (const t in e) i += t.startsWith("--") ? t : t.replace(/[A-Z]/g, he), i += `: ${e[t]}; `;
        return i
    }, t.createStyles = ae, t.getAnimationData = I, t.getStyleName = Q, t.glide = Ct, t.inView = At, t.mountedStates = le, t.resize = Tt, t.scroll = function(t, e = {}) {
        var {
            container: i = document.documentElement
        } = e, n = ut(e, ["container"]);
        let s = Vt.get(i);
        s || (s = new Set, Vt.set(i, s));
        const o = Ht(i, t, {
            time: 0,
            x: {
                current: 0,
                offset: [],
                progress: 0,
                scrollLength: 0,
                targetOffset: 0,
                targetLength: 0,
                containerLength: 0,
                velocity: 0
            },
            y: {
                current: 0,
                offset: [],
                progress: 0,
                scrollLength: 0,
                targetOffset: 0,
                targetLength: 0,
                containerLength: 0,
                velocity: 0
            }
        }, n);
        if (s.add(o), !Rt.has(i)) {
            const t = () => {
                const t = performance.now();
                for (const t of s) t.measure();
                for (const e of s) e.update(t);
                for (const t of s) t.notify()
            };
            Rt.set(i, t);
            const e = Xt(i);
            window.addEventListener("resize", t, {
                passive: !0
            }), i !== document.documentElement && Ut.set(i, Tt(i, t)), e.addEventListener("scroll", t, {
                passive: !0
            })
        }
        const r = Rt.get(i),
            l = requestAnimationFrame(r);
        return () => {
            var e;
            "function" != typeof t && t.stop(), cancelAnimationFrame(l);
            const n = Vt.get(i);
            if (!n) return;
            if (n.delete(o), n.size) return;
            const s = Rt.get(i);
            Rt.delete(i), s && (Xt(i).removeEventListener("scroll", s), null === (e = Ut.get(i)) || void 0 === e || e(), window.removeEventListener("resize", s))
        }
    }, t.spring = xt, t.stagger = function(t = .1, {
        start: e = 0,
        from: i = 0,
        easing: n
    } = {}) {
        return (s, r) => {
            const l = o(i) ? i : function(t, e) {
                    if ("first" === t) return 0;
                    {
                        const i = e - 1;
                        return "last" === t ? i : i / 2
                    }
                }(i, r),
                a = Math.abs(l - s);
            let h = t * a;
            if (n) {
                const e = r * t;
                h = A(n)(h / e) * e
            }
            return e + h
        }
    }, t.style = J, t.timeline = function(t, e = {}) {
        var i;
        const n = function(t, e = {}) {
                var {
                    defaultOptions: i = {}
                } = e, n = ut(e, ["defaultOptions"]);
                const o = [],
                    r = new Map,
                    l = {},
                    a = new Map;
                let h = 0,
                    c = 0,
                    f = 0;
                for (let e = 0; e < t.length; e++) {
                    const n = t[e];
                    if (v(n)) {
                        a.set(n, c);
                        continue
                    }
                    if (!Array.isArray(n)) {
                        a.set(n.name, pt(c, n.at, h, a));
                        continue
                    }
                    const [o, d, g = {}] = n;
                    void 0 !== g.at && (c = pt(c, g.at, h, a));
                    let y = 0;
                    const w = st(o, l),
                        b = w.length;
                    for (let t = 0; t < b; t++) {
                        const e = mt(w[t], r);
                        for (const n in d) {
                            const o = yt(n, e);
                            let r = K(d[n]);
                            const l = nt(g, n);
                            let {
                                duration: a = i.duration || s.duration,
                                easing: h = i.easing || s.easing
                            } = l;
                            if (m(h)) {
                                "opacity" === n || r.length;
                                const t = h.createAnimation(r, "opacity" !== n, (() => 0), n);
                                h = t.easing, r = t.keyframes || r, a = t.duration || a
                            }
                            const v = ht(g.delay, t, b) || 0,
                                w = c + v,
                                S = w + a;
                            let {
                                offset: E = p(r.length)
                            } = l;
                            1 === E.length && 0 === E[0] && (E[1] = 1);
                            const x = E.length - r.length;
                            x > 0 && u(E, x), 1 === r.length && r.unshift(null), ft(o, r, h, E, w, S), y = Math.max(v + a, y), f = Math.max(S, f)
                        }
                    }
                    h = c, c += y
                }
                return r.forEach(((t, e) => {
                    for (const r in t) {
                        const l = t[r];
                        l.sort(gt);
                        const a = [],
                            h = [],
                            c = [];
                        for (let t = 0; t < l.length; t++) {
                            const {
                                at: e,
                                value: i,
                                easing: n
                            } = l[t];
                            a.push(i), h.push(d(0, f, e)), c.push(n || s.easing)
                        }
                        0 !== h[0] && (h.unshift(0), a.unshift(a[0]), c.unshift("linear")), 1 !== h[h.length - 1] && (h.push(1), a.push(null)), o.push([e, r, a, Object.assign(Object.assign(Object.assign({}, i), {
                            duration: f,
                            easing: c,
                            offset: h
                        }), n)])
                    }
                })), o
            }(t, e),
            o = n.map((t => it(...t, P))).filter(Boolean);
        return rt(o, e, null === (i = n[0]) || void 0 === i ? void 0 : i[3].duration)
    }, t.withControls = rt, Object.defineProperty(t, "__esModule", {
        value: !0
    })
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, (function() {
    function t() {}
    let e = t.prototype;
    return e.on = function(t, e) {
        if (!t || !e) return this;
        let i = this._events = this._events || {},
            n = i[t] = i[t] || [];
        return n.includes(e) || n.push(e), this
    }, e.once = function(t, e) {
        if (!t || !e) return this;
        this.on(t, e);
        let i = this._onceEvents = this._onceEvents || {};
        return (i[t] = i[t] || {})[e] = !0, this
    }, e.off = function(t, e) {
        let i = this._events && this._events[t];
        if (!i || !i.length) return this;
        let n = i.indexOf(e);
        return -1 != n && i.splice(n, 1), this
    }, e.emitEvent = function(t, e) {
        let i = this._events && this._events[t];
        if (!i || !i.length) return this;
        i = i.slice(0), e = e || [];
        let n = this._onceEvents && this._onceEvents[t];
        for (let s of i) n && n[s] && (this.off(t, s), delete n[s]), s.apply(this, e);
        return this
    }, e.allOff = function() {
        return delete this._events, delete this._onceEvents, this
    }, t
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, (function() {
    function t(t) {
        let e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }
    let e = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"];
    return e.length,
        function(i) {
            if ("string" == typeof i && (i = document.querySelector(i)), !i || "object" != typeof i || !i.nodeType) return;
            let n = getComputedStyle(i);
            if ("none" == n.display) return function() {
                let t = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0
                };
                return e.forEach((e => {
                    t[e] = 0
                })), t
            }();
            let s = {};
            s.width = i.offsetWidth, s.height = i.offsetHeight;
            let o = s.isBorderBox = "border-box" == n.boxSizing;
            e.forEach((t => {
                let e = n[t],
                    i = parseFloat(e);
                s[t] = isNaN(i) ? 0 : i
            }));
            let r = s.paddingLeft + s.paddingRight,
                l = s.paddingTop + s.paddingBottom,
                a = s.marginLeft + s.marginRight,
                h = s.marginTop + s.marginBottom,
                c = s.borderLeftWidth + s.borderRightWidth,
                d = s.borderTopWidth + s.borderBottomWidth,
                u = t(n.width);
            !1 !== u && (s.width = u + (o ? 0 : r + c));
            let p = t(n.height);
            return !1 !== p && (s.height = p + (o ? 0 : l + d)), s.innerWidth = s.width - (r + c), s.innerHeight = s.height - (l + d), s.outerWidth = s.width + a, s.outerHeight = s.height + h, s
        }
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(t) : t.fizzyUIUtils = e(t)
}(this, (function(t) {
    let e = {
            extend: function(t, e) {
                return Object.assign(t, e)
            },
            modulo: function(t, e) {
                return (t % e + e) % e
            },
            makeArray: function(t) {
                return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? [...t] : [t]
            },
            removeFrom: function(t, e) {
                let i = t.indexOf(e); - 1 != i && t.splice(i, 1)
            },
            getParent: function(t, e) {
                for (; t.parentNode && t != document.body;)
                    if ((t = t.parentNode).matches(e)) return t
            },
            getQueryElement: function(t) {
                return "string" == typeof t ? document.querySelector(t) : t
            },
            handleEvent: function(t) {
                let e = "on" + t.type;
                this[e] && this[e](t)
            },
            filterFindElements: function(t, i) {
                return (t = e.makeArray(t)).filter((t => t instanceof HTMLElement)).reduce(((t, e) => {
                    if (!i) return t.push(e), t;
                    e.matches(i) && t.push(e);
                    let n = e.querySelectorAll(i);
                    return t.concat(...n)
                }), [])
            },
            debounceMethod: function(t, e, i) {
                i = i || 100;
                let n = t.prototype[e],
                    s = e + "Timeout";
                t.prototype[e] = function() {
                    clearTimeout(this[s]);
                    let t = arguments;
                    this[s] = setTimeout((() => {
                        n.apply(this, t), delete this[s]
                    }), i)
                }
            },
            docReady: function(t) {
                let e = document.readyState;
                "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
            },
            toDashed: function(t) {
                return t.replace(/(.)([A-Z])/g, (function(t, e, i) {
                    return e + "-" + i
                })).toLowerCase()
            }
        },
        i = t.console;
    return e.htmlInit = function(t, n) {
        e.docReady((function() {
            let s = "data-" + e.toDashed(n);
            [...document.querySelectorAll(`[${s}]`)].forEach((e => {
                let n, o = e.getAttribute(s);
                try {
                    n = o && JSON.parse(o)
                } catch (n) {
                    return void(i && i.error(`Error parsing ${s}on ${e.className}:${n}`))
                }
                new t(e, n)
            }))
        }))
    }, e
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(t, require("ev-emitter")) : t.Unidragger = e(t, t.EvEmitter)
}("undefined" != typeof window ? window : this, (function(t, e) {
    function i() {}
    let n, s, o = i.prototype = Object.create(e.prototype);
    o.handleEvent = function(t) {
        let e = "on" + t.type;
        this[e] && this[e](t)
    }, "ontouchstart" in t ? (n = "touchstart", s = ["touchmove", "touchend", "touchcancel"]) : t.PointerEvent ? (n = "pointerdown", s = ["pointermove", "pointerup", "pointercancel"]) : (n = "mousedown", s = ["mousemove", "mouseup"]), o.touchActionValue = "none", o.bindHandles = function() {
        this._bindHandles("addEventListener", this.touchActionValue)
    }, o.unbindHandles = function() {
        this._bindHandles("removeEventListener", "")
    }, o._bindHandles = function(e, i) {
        this.handles.forEach((s => {
            s[e](n, this), s[e]("click", this), t.PointerEvent && (s.style.touchAction = i)
        }))
    }, o.bindActivePointerEvents = function() {
        s.forEach((e => {
            t.addEventListener(e, this)
        }))
    }, o.unbindActivePointerEvents = function() {
        s.forEach((e => {
            t.removeEventListener(e, this)
        }))
    }, o.withPointer = function(t, e) {
        e.pointerId === this.pointerIdentifier && this[t](e, e)
    }, o.withTouch = function(t, e) {
        let i;
        for (let t of e.changedTouches) t.identifier === this.pointerIdentifier && (i = t);
        i && this[t](e, i)
    }, o.onmousedown = function(t) {
        this.pointerDown(t, t)
    }, o.ontouchstart = function(t) {
        this.pointerDown(t, t.changedTouches[0])
    }, o.onpointerdown = function(t) {
        this.pointerDown(t, t)
    };
    const r = ["TEXTAREA", "INPUT", "SELECT", "OPTION"],
        l = ["radio", "checkbox", "button", "submit", "image", "file"];
    return o.pointerDown = function(t, e) {
        let i = r.includes(t.target.nodeName),
            n = l.includes(t.target.type),
            s = !i || n;
        !this.isPointerDown && !t.button && s && (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier, this.pointerDownPointer = {
            pageX: e.pageX,
            pageY: e.pageY
        }, this.bindActivePointerEvents(), this.emitEvent("pointerDown", [t, e]))
    }, o.onmousemove = function(t) {
        this.pointerMove(t, t)
    }, o.onpointermove = function(t) {
        this.withPointer("pointerMove", t)
    }, o.ontouchmove = function(t) {
        this.withTouch("pointerMove", t)
    }, o.pointerMove = function(t, e) {
        let i = {
            x: e.pageX - this.pointerDownPointer.pageX,
            y: e.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent("pointerMove", [t, e, i]), !this.isDragging && this.hasDragStarted(i) && this.dragStart(t, e), this.isDragging && this.dragMove(t, e, i)
    }, o.hasDragStarted = function(t) {
        return Math.abs(t.x) > 3 || Math.abs(t.y) > 3
    }, o.dragStart = function(t, e) {
        this.isDragging = !0, this.isPreventingClicks = !0, this.emitEvent("dragStart", [t, e])
    }, o.dragMove = function(t, e, i) {
        this.emitEvent("dragMove", [t, e, i])
    }, o.onmouseup = function(t) {
        this.pointerUp(t, t)
    }, o.onpointerup = function(t) {
        this.withPointer("pointerUp", t)
    }, o.ontouchend = function(t) {
        this.withTouch("pointerUp", t)
    }, o.pointerUp = function(t, e) {
        this.pointerDone(), this.emitEvent("pointerUp", [t, e]), this.isDragging ? this.dragEnd(t, e) : this.staticClick(t, e)
    }, o.dragEnd = function(t, e) {
        this.isDragging = !1, setTimeout((() => delete this.isPreventingClicks)), this.emitEvent("dragEnd", [t, e])
    }, o.pointerDone = function() {
        this.isPointerDown = !1, delete this.pointerIdentifier, this.unbindActivePointerEvents(), this.emitEvent("pointerDone")
    }, o.onpointercancel = function(t) {
        this.withPointer("pointerCancel", t)
    }, o.ontouchcancel = function(t) {
        this.withTouch("pointerCancel", t)
    }, o.pointerCancel = function(t, e) {
        this.pointerDone(), this.emitEvent("pointerCancel", [t, e])
    }, o.onclick = function(t) {
        this.isPreventingClicks && t.preventDefault()
    }, o.staticClick = function(t, e) {
        let i = "mouseup" === t.type;
        i && this.isIgnoringMouseUp || (this.emitEvent("staticClick", [t, e]), i && (this.isIgnoringMouseUp = !0, setTimeout((() => {
            delete this.isIgnoringMouseUp
        }), 400)))
    }, i
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(require("get-size")) : (t.Flickity = t.Flickity || {}, t.Flickity.Cell = e(t.getSize))
}("undefined" != typeof window ? window : this, (function(t) {
    const e = "flickity-cell";

    function i(t) {
        this.element = t, this.element.classList.add(e), this.x = 0, this.unselect()
    }
    let n = i.prototype;
    return n.destroy = function() {
        this.unselect(), this.element.classList.remove(e), this.element.style.transform = "", this.element.removeAttribute("aria-hidden")
    }, n.getSize = function() {
        this.size = t(this.element)
    }, n.select = function() {
        this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
    }, n.unselect = function() {
        this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
    }, n.remove = function() {
        this.element.remove()
    }, i
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e() : (t.Flickity = t.Flickity || {}, t.Flickity.Slide = e())
}("undefined" != typeof window ? window : this, (function() {
    function t(t, e, i) {
        this.beginMargin = t, this.endMargin = e, this.cellAlign = i, this.cells = [], this.outerWidth = 0, this.height = 0
    }
    let e = t.prototype;
    return e.addCell = function(t) {
        this.cells.push(t), this.outerWidth += t.size.outerWidth, this.height = Math.max(t.size.outerHeight, this.height), 1 === this.cells.length && (this.x = t.x, this.firstMargin = t.size[this.beginMargin])
    }, e.updateTarget = function() {
        let t = this.getLastCell(),
            e = t ? t.size[this.endMargin] : 0,
            i = this.outerWidth - (this.firstMargin + e);
        this.target = this.x + this.firstMargin + i * this.cellAlign
    }, e.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }, e.select = function() {
        this.cells.forEach((t => t.select()))
    }, e.unselect = function() {
        this.cells.forEach((t => t.unselect()))
    }, e.getCellElements = function() {
        return this.cells.map((t => t.element))
    }, t
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(require("fizzy-ui-utils")) : (t.Flickity = t.Flickity || {}, t.Flickity.animatePrototype = e(t.fizzyUIUtils))
}("undefined" != typeof window ? window : this, (function(t) {
    return {
        startAnimation: function() {
            this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
        },
        animate: function() {
            this.applyDragForce(), this.applySelectedAttraction();
            let t = this.x;
            this.integratePhysics(), this.positionSlider(), this.settle(t), this.isAnimating && requestAnimationFrame((() => this.animate()))
        },
        positionSlider: function() {
            let e = this.x;
            this.isWrapping && (e = t.modulo(e, this.slideableWidth) - this.slideableWidth, this.shiftWrapCells(e)), this.setTranslateX(e, this.isAnimating), this.dispatchScrollEvent()
        },
        setTranslateX: function(t, e) {
            t += this.cursorPosition, this.options.rightToLeft && (t = -t);
            let i = this.getPositionValue(t);
            this.slider.style.transform = e ? `translate3d(${i},0,0)` : `translateX(${i})`
        },
        dispatchScrollEvent: function() {
            let t = this.slides[0];
            if (!t) return;
            let e = -this.x - t.target,
                i = e / this.slidesWidth;
            this.dispatchEvent("scroll", null, [i, e])
        },
        positionSliderAtSelected: function() {
            this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
        },
        getPositionValue: function(t) {
            return this.options.percentPosition ? .01 * Math.round(t / this.size.innerWidth * 1e4) + "%" : Math.round(t) + "px"
        },
        settle: function(t) {
            !this.isPointerDown && Math.round(100 * this.x) === Math.round(100 * t) && this.restingFrames++, this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
        },
        shiftWrapCells: function(t) {
            let e = this.cursorPosition + t;
            this._shiftCells(this.beforeShiftCells, e, -1);
            let i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
            this._shiftCells(this.afterShiftCells, i, 1)
        },
        _shiftCells: function(t, e, i) {
            t.forEach((t => {
                let n = e > 0 ? i : 0;
                this._wrapShiftCell(t, n), e -= t.size.outerWidth
            }))
        },
        _unshiftCells: function(t) {
            t && t.length && t.forEach((t => this._wrapShiftCell(t, 0)))
        },
        _wrapShiftCell: function(t, e) {
            this._renderCellPosition(t, t.x + this.slideableWidth * e)
        },
        integratePhysics: function() {
            this.x += this.velocity, this.velocity *= this.getFrictionFactor()
        },
        applyForce: function(t) {
            this.velocity += t
        },
        getFrictionFactor: function() {
            return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        },
        getRestingPosition: function() {
            return this.x + this.velocity / (1 - this.getFrictionFactor())
        },
        applyDragForce: function() {
            if (!this.isDraggable || !this.isPointerDown) return;
            let t = this.dragX - this.x - this.velocity;
            this.applyForce(t)
        },
        applySelectedAttraction: function() {
            if (this.isDraggable && this.isPointerDown || this.isFreeScrolling || !this.slides.length) return;
            let t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
            this.applyForce(t)
        }
    }
})),
function(t, e) {
    if ("object" == typeof module && module.exports) module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
    else {
        let i = t.Flickity;
        t.Flickity = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, i.Cell, i.Slide, i.animatePrototype)
    }
}("undefined" != typeof window ? window : this, (function(t, e, i, n, s, o, r) {
    const {
        getComputedStyle: l
    } = t;
    let {
        jQuery: a
    } = t, h = 0, c = {};

    function d(t, e) {
        let i = n.getQueryElement(t);
        if (i) {
            if (this.element = i, this.element.flickityGUID) {
                let t = c[this.element.flickityGUID];
                return t && t.option(e), t
            }
            this.options = {
                ...this.constructor.defaults
            }, this.option(e), this._create()
        }
    }
    d.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
    }, d.create = {};
    let u = d.prototype;
    Object.assign(u, e.prototype), u._create = function() {
        let {
            resize: e,
            watchCSS: i,
            rightToLeft: n
        } = this.options, s = this.guid = ++h;
        this.element.flickityGUID = s, c[s] = this, this.selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.beginMargin = n ? "marginRight" : "marginLeft", this.endMargin = n ? "marginLeft" : "marginRight", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), this.focusableElems = [this.element], (e || i) && t.addEventListener("resize", this);
        for (let t in this.options.on) {
            let e = this.options.on[t];
            this.on(t, e)
        }
        for (let t in d.create) d.create[t].call(this);
        i ? this.watchCSS() : this.activate()
    }, u.option = function(t) {
        Object.assign(this.options, t)
    }, u.activate = function() {
        if (this.isActive) return;
        this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize();
        let t = this._filterFindCellElements(this.element.children);
        this.slider.append(...t), this.viewport.append(this.slider), this.element.append(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready")
    }, u._createSlider = function() {
        let t = document.createElement("div");
        t.className = "flickity-slider", this.slider = t
    }, u._filterFindCellElements = function(t) {
        return n.filterFindElements(t, this.options.cellSelector)
    }, u.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children), this.positionCells(), this._updateWrapShiftCells(), this.setGallerySize()
    }, u._makeCells = function(t) {
        return this._filterFindCellElements(t).map((t => new s(t)))
    }, u.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }, u.getLastSlide = function() {
        return this.slides[this.slides.length - 1]
    }, u.positionCells = function() {
        this._sizeCells(this.cells), this._positionCells(0)
    }, u._positionCells = function(t) {
        t = t || 0, this.maxCellHeight = t && this.maxCellHeight || 0;
        let e = 0;
        if (t > 0) {
            let i = this.cells[t - 1];
            e = i.x + i.size.outerWidth
        }
        this.cells.slice(t).forEach((t => {
            t.x = e, this._renderCellPosition(t, e), e += t.size.outerWidth, this.maxCellHeight = Math.max(t.size.outerHeight, this.maxCellHeight)
        })), this.slideableWidth = e, this.updateSlides(), this._containSlides(), this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0
    }, u._renderCellPosition = function(t, e) {
        let i = e * (this.options.rightToLeft ? -1 : 1);
        this.options.percentPosition && (i *= this.size.innerWidth / t.size.width);
        let n = this.getPositionValue(i);
        t.element.style.transform = `translateX(${n})`
    }, u._sizeCells = function(t) {
        t.forEach((t => t.getSize()))
    }, u.updateSlides = function() {
        if (this.slides = [], !this.cells.length) return;
        let {
            beginMargin: t,
            endMargin: e
        } = this, i = new o(t, e, this.cellAlign);
        this.slides.push(i);
        let n = this._getCanCellFit();
        this.cells.forEach(((s, r) => {
            if (!i.cells.length) return void i.addCell(s);
            let l = i.outerWidth - i.firstMargin + (s.size.outerWidth - s.size[e]);
            n(r, l) || (i.updateTarget(), i = new o(t, e, this.cellAlign), this.slides.push(i)), i.addCell(s)
        })), i.updateTarget(), this.updateSelectedSlide()
    }, u._getCanCellFit = function() {
        let {
            groupCells: t
        } = this.options;
        if (!t) return () => !1;
        if ("number" == typeof t) {
            let e = parseInt(t, 10);
            return t => t % e != 0
        }
        let e = 1,
            i = "string" == typeof t && t.match(/^(\d+)%$/);
        i && (e = parseInt(i[1], 10) / 100);
        let n = (this.size.innerWidth + 1) * e;
        return (t, e) => e <= n
    }, u._init = u.reposition = function() {
        this.positionCells(), this.positionSliderAtSelected()
    }, u.getSize = function() {
        this.size = i(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
    };
    let p = {
        left: 0,
        center: .5,
        right: 1
    };
    u.setCellAlign = function() {
        let {
            cellAlign: t,
            rightToLeft: e
        } = this.options, i = p[t];
        this.cellAlign = void 0 !== i ? i : t, e && (this.cellAlign = 1 - this.cellAlign)
    }, u.setGallerySize = function() {
        if (!this.options.setGallerySize) return;
        let t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = `${t}px`
    }, u._updateWrapShiftCells = function() {
        if (this.isWrapping = this.getIsWrapping(), !this.isWrapping) return;
        this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
        let t = this.cursorPosition,
            e = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(t, e, -1);
        let i = this.size.innerWidth - this.cursorPosition;
        this.afterShiftCells = this._getGapCells(i, 0, 1)
    }, u.getIsWrapping = function() {
        let {
            wrapAround: t
        } = this.options;
        if (!t || this.slides.length < 2) return !1;
        if ("fill" !== t) return !0;
        let e = this.slideableWidth - this.size.innerWidth;
        if (e > this.size.innerWidth) return !0;
        for (let t of this.cells)
            if (t.size.outerWidth > e) return !1;
        return !0
    }, u._getGapCells = function(t, e, i) {
        let n = [];
        for (; t > 0;) {
            let s = this.cells[e];
            if (!s) break;
            n.push(s), e += i, t -= s.size.outerWidth
        }
        return n
    }, u._containSlides = function() {
        if (!this.options.contain || this.isWrapping || !this.cells.length) return;
        let t = this.slideableWidth - this.getLastCell().size[this.endMargin];
        if (t < this.size.innerWidth) this.slides.forEach((e => {
            e.target = t * this.cellAlign
        }));
        else {
            let e = this.cursorPosition + this.cells[0].size[this.beginMargin],
                i = t - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((t => {
                t.target = Math.max(t.target, e), t.target = Math.min(t.target, i)
            }))
        }
    }, u.dispatchEvent = function(t, e, i) {
        let n = e ? [e].concat(i) : i;
        this.emitEvent(t, n)
    };
    const f = ["dragStart", "dragMove", "dragEnd", "pointerDown", "pointerMove", "pointerEnd", "staticClick"];
    let g = u.emitEvent;
    return u.emitEvent = function(t, e) {
        if ("staticClick" === t) {
            let t = this.getParentCell(e[0].target),
                i = t && t.element,
                n = t && this.cells.indexOf(t);
            e = e.concat(i, n)
        }
        g.call(this, t, e), f.includes(t) && this.$element
    }, u.select = function(t, e, i) {
        if (!this.isActive) return;
        if (t = parseInt(t, 10), this._wrapSelect(t), (this.isWrapping || e) && (t = n.modulo(t, this.slides.length)), !this.slides[t]) return;
        let s = this.selectedIndex;
        this.selectedIndex = t, this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [t]), t !== s && this.dispatchEvent("change", null, [t])
    }, u._wrapSelect = function(t) {
        if (!this.isWrapping) return;
        const {
            selectedIndex: e,
            slideableWidth: i,
            slides: {
                length: s
            }
        } = this;
        if (!this.isDragSelect) {
            let i = n.modulo(t, s),
                o = Math.abs(i - e),
                r = Math.abs(i + s - e),
                l = Math.abs(i - s - e);
            r < o ? t += s : l < o && (t -= s)
        }
        t < 0 ? this.x -= i : t >= s && (this.x += i)
    }, u.previous = function(t, e) {
        this.select(this.selectedIndex - 1, t, e)
    }, u.next = function(t, e) {
        this.select(this.selectedIndex + 1, t, e)
    }, u.updateSelectedSlide = function() {
        let t = this.slides[this.selectedIndex];
        t && (this.unselectSelectedSlide(), this.selectedSlide = t, t.select(), this.selectedCells = t.cells, this.selectedElements = t.getCellElements(), this.selectedCell = t.cells[0], this.selectedElement = this.selectedElements[0])
    }, u.unselectSelectedSlide = function() {
        this.selectedSlide && this.selectedSlide.unselect()
    }, u.selectInitialIndex = function() {
        let t = this.options.initialIndex;
        if (this.isInitActivated) return void this.select(this.selectedIndex, !1, !0);
        if (t && "string" == typeof t && this.queryCell(t)) return void this.selectCell(t, !1, !0);
        let e = 0;
        t && this.slides[t] && (e = t), this.select(e, !1, !0)
    }, u.selectCell = function(t, e, i) {
        let n = this.queryCell(t);
        if (!n) return;
        let s = this.getCellSlideIndex(n);
        this.select(s, e, i)
    }, u.getCellSlideIndex = function(t) {
        let e = this.slides.find((e => e.cells.includes(t)));
        return this.slides.indexOf(e)
    }, u.getCell = function(t) {
        for (let e of this.cells)
            if (e.element === t) return e
    }, u.getCells = function(t) {
        return (t = n.makeArray(t)).map((t => this.getCell(t))).filter(Boolean)
    }, u.getCellElements = function() {
        return this.cells.map((t => t.element))
    }, u.getParentCell = function(t) {
        let e = this.getCell(t);
        if (e) return e;
        let i = t.closest(".flickity-slider > *");
        return this.getCell(i)
    }, u.getAdjacentCellElements = function(t, e) {
        if (!t) return this.selectedSlide.getCellElements();
        e = void 0 === e ? this.selectedIndex : e;
        let i = this.slides.length,
            s = [];
        for (let o = e - t; o <= e + t; o++) {
            let t = this.isWrapping ? n.modulo(o, i) : o,
                e = this.slides[t];
            e && (s = s.concat(e.getCellElements()))
        }
        return s
    }, u.queryCell = function(t) {
        return "number" == typeof t ? this.cells[t] : ("string" == typeof t && !t.match(/^[#.]?[\d/]/) && (t = this.element.querySelector(t)), this.getCell(t))
    }, u.uiChange = function() {
        this.emitEvent("uiChange")
    }, u.onresize = function() {
        this.watchCSS(), this.resize()
    }, n.debounceMethod(d, "onresize", 150), u.resize = function() {
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize(), this.isWrapping && (this.x = n.modulo(this.x, this.slideableWidth)), this.positionCells(), this._updateWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
        let t = this.selectedElements && this.selectedElements[0];
        this.selectCell(t, !1, !0)
    }, u.watchCSS = function() {
        this.options.watchCSS && (l(this.element, ":after").content.includes("flickity") ? this.activate() : this.deactivate())
    }, u.onkeydown = function(t) {
        let {
            activeElement: e
        } = document, i = d.keyboardHandlers[t.key];
        this.options.accessibility && e && i && this.focusableElems.some((t => e === t)) && i.call(this)
    }, d.keyboardHandlers = {
        ArrowLeft: function() {
            this.uiChange(), this[this.options.rightToLeft ? "next" : "previous"]()
        },
        ArrowRight: function() {
            this.uiChange(), this[this.options.rightToLeft ? "previous" : "next"]()
        }
    }, u.focus = function() {
        this.element.focus({
            preventScroll: !0
        })
    }, u.deactivate = function() {
        this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach((t => t.destroy())), this.viewport.remove(), this.element.append(...this.slider.children), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
    }, u.destroy = function() {
        this.deactivate(), t.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), delete this.element.flickityGUID, delete c[this.guid]
    }, Object.assign(u, r), d.data = function(t) {
        if (t = n.getQueryElement(t)) return c[t.flickityGUID]
    }, n.htmlInit(d, "flickity"), d.Cell = s, d.Slide = o, d
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(t, require("./core"), require("unidragger"), require("fizzy-ui-utils")) : t.Flickity = e(t, t.Flickity, t.Unidragger, t.fizzyUIUtils)
}("undefined" != typeof window ? window : this, (function(t, e, i, n) {
    Object.assign(e.defaults, {
        draggable: ">1",
        dragThreshold: 3
    });
    let s = e.prototype;

    function o() {
        return {
            x: t.pageXOffset,
            y: t.pageYOffset
        }
    }
    return Object.assign(s, i.prototype), s.touchActionValue = "", e.create.drag = function() {
        this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), this.on("pointerDown", this.handlePointerDown), this.on("pointerUp", this.handlePointerUp), this.on("pointerDown", this.handlePointerDone), this.on("dragStart", this.handleDragStart), this.on("dragMove", this.handleDragMove), this.on("dragEnd", this.handleDragEnd), this.on("staticClick", this.handleStaticClick)
    }, s.onActivateDrag = function() {
        this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
    }, s.onDeactivateDrag = function() {
        this.unbindHandles(), this.element.classList.remove("is-draggable")
    }, s.updateDraggable = function() {
        ">1" === this.options.draggable ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable, this.element.classList.toggle("is-draggable", this.isDraggable)
    }, s._uiChangeDrag = function() {
        delete this.isFreeScrolling
    }, s.handlePointerDown = function(e) {
        if (!this.isDraggable) return void this.bindActivePointerEvents(e);
        let i = "touchstart" === e.type,
            n = "touch" === e.pointerType,
            s = e.target.matches("input, textarea, select");
        i || n || s || e.preventDefault(), s || this.focus(), document.activeElement !== this.element && document.activeElement.blur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = o(), t.addEventListener("scroll", this), this.bindActivePointerEvents(e)
    }, s.hasDragStarted = function(t) {
        return Math.abs(t.x) > this.options.dragThreshold
    }, s.handlePointerUp = function() {
        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down")
    }, s.handlePointerDone = function() {
        t.removeEventListener("scroll", this), delete this.pointerDownScroll
    }, s.handleDragStart = function() {
        this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), t.removeEventListener("scroll", this))
    }, s.handleDragMove = function(t, e, i) {
        if (!this.isDraggable) return;
        t.preventDefault(), this.previousDragX = this.dragX;
        let n = this.options.rightToLeft ? -1 : 1;
        this.isWrapping && (i.x %= this.slideableWidth);
        let s = this.dragStartPosition + i.x * n;
        if (!this.isWrapping) {
            let t = Math.max(-this.slides[0].target, this.dragStartPosition);
            s = s > t ? .5 * (s + t) : s;
            let e = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            s = s < e ? .5 * (s + e) : s
        }
        this.dragX = s, this.dragMoveTime = new Date
    }, s.handleDragEnd = function() {
        if (!this.isDraggable) return;
        let {
            freeScroll: t
        } = this.options;
        t && (this.isFreeScrolling = !0);
        let e = this.dragEndRestingSelect();
        if (t && !this.isWrapping) {
            let t = this.getRestingPosition();
            this.isFreeScrolling = -t > this.slides[0].target && -t < this.getLastSlide().target
        } else t || e !== this.selectedIndex || (e += this.dragEndBoostSelect());
        delete this.previousDragX, this.isDragSelect = this.isWrapping, this.select(e), delete this.isDragSelect
    }, s.dragEndRestingSelect = function() {
        let t = this.getRestingPosition(),
            e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
            i = this._getClosestResting(t, e, 1),
            n = this._getClosestResting(t, e, -1);
        return i.distance < n.distance ? i.index : n.index
    }, s._getClosestResting = function(t, e, i) {
        let n = this.selectedIndex,
            s = 1 / 0,
            o = this.options.contain && !this.isWrapping ? (t, e) => t <= e : (t, e) => t < e;
        for (; o(e, s) && (n += i, s = e, null !== (e = this.getSlideDistance(-t, n)));) e = Math.abs(e);
        return {
            distance: s,
            index: n - i
        }
    }, s.getSlideDistance = function(t, e) {
        let i = this.slides.length,
            s = this.options.wrapAround && i > 1,
            o = s ? n.modulo(e, i) : e,
            r = this.slides[o];
        if (!r) return null;
        let l = s ? this.slideableWidth * Math.floor(e / i) : 0;
        return t - (r.target + l)
    }, s.dragEndBoostSelect = function() {
        if (void 0 === this.previousDragX || !this.dragMoveTime || new Date - this.dragMoveTime > 100) return 0;
        let t = this.getSlideDistance(-this.dragX, this.selectedIndex),
            e = this.previousDragX - this.dragX;
        return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0
    }, s.onscroll = function() {
        let t = o(),
            e = this.pointerDownScroll.x - t.x,
            i = this.pointerDownScroll.y - t.y;
        (Math.abs(e) > 3 || Math.abs(i) > 3) && this.pointerDone()
    }, e
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(require("./core")) : e(t.Flickity)
}("undefined" != typeof window ? window : this, (function(t) {
    const e = "http://www.w3.org/2000/svg";

    function i(t, e, i) {
        this.increment = t, this.direction = e, this.isPrevious = "previous" === t, this.isLeft = "left" === e, this._create(i)
    }
    i.prototype._create = function(t) {
        let e = this.element = document.createElement("button");
        e.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let i = this.isPrevious ? "Previous" : "Next";
        e.setAttribute("type", "button"), e.setAttribute("aria-label", i), this.disable();
        let n = this.createSVG(i, t);
        e.append(n)
    }, i.prototype.createSVG = function(t, i) {
        let n = document.createElementNS(e, "svg");
        n.setAttribute("class", "flickity-button-icon"), n.setAttribute("viewBox", "0 0 100 100");
        let s = document.createElementNS(e, "title");
        s.append(t);
        let o = document.createElementNS(e, "path"),
            r = function(t) {
                if ("string" == typeof t) return t;
                let {
                    x0: e,
                    x1: i,
                    x2: n,
                    x3: s,
                    y1: o,
                    y2: r
                } = t;
                return `M ${e},50\n L ${i},${o+50}\n L ${n},${r+50}\n L ${s},50\n L ${n},${50-r}\n L ${i},${50-o}\n Z`
            }(i);
        return o.setAttribute("d", r), o.setAttribute("class", "arrow"), this.isLeft || o.setAttribute("transform", "translate(100, 100) rotate(180)"), n.append(s, o), n
    }, i.prototype.enable = function() {
        this.element.removeAttribute("disabled")
    }, i.prototype.disable = function() {
        this.element.setAttribute("disabled", !0)
    }, Object.assign(t.defaults, {
        prevNextButtons: !0,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    }), t.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let {
            rightToLeft: t,
            arrowShape: e
        } = this.options, n = t ? "right" : "left", s = t ? "left" : "right";
        this.prevButton = new i("previous", n, e), this.nextButton = new i("next", s, e), this.focusableElems.push(this.prevButton.element), this.focusableElems.push(this.nextButton.element), this.handlePrevButtonClick = () => {
            this.uiChange(), this.previous()
        }, this.handleNextButtonClick = () => {
            this.uiChange(), this.next()
        }, this.on("activate", this.activatePrevNextButtons), this.on("select", this.updatePrevNextButtons)
    };
    let n = t.prototype;
    return n.updatePrevNextButtons = function() {
        let t = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0), this.updatePrevNextButton(this.nextButton, t)
    }, n.updatePrevNextButton = function(t, e) {
        if (this.isWrapping && this.slides.length > 1) return void t.enable();
        let i = this.selectedIndex !== e;
        t[i ? "enable" : "disable"](), !i && document.activeElement === t.element && this.focus()
    }, n.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener("click", this.handlePrevButtonClick), this.nextButton.element.addEventListener("click", this.handleNextButtonClick), this.element.prepend(this.prevButton.element, this.nextButton.element), this.on("deactivate", this.deactivatePrevNextButtons)
    }, n.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove(), this.nextButton.element.remove(), this.prevButton.element.removeEventListener("click", this.handlePrevButtonClick), this.nextButton.element.removeEventListener("click", this.handleNextButtonClick), this.off("deactivate", this.deactivatePrevNextButtons)
    }, t.PrevNextButton = i, t
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(require("./core"), require("fizzy-ui-utils")) : e(t.Flickity, t.fizzyUIUtils)
}("undefined" != typeof window ? window : this, (function(t, e) {
    function i() {
        this.holder = document.createElement("div"), this.holder.className = "flickity-page-dots", this.dots = []
    }
    i.prototype.setDots = function(t) {
        let e = t - this.dots.length;
        e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e)
    }, i.prototype.addDots = function(t) {
        let e = new Array(t).fill().map(((t, e) => {
            let i = document.createElement("button");
            i.setAttribute("type", "button");
            let n = e + 1 + this.dots.length;
            return i.className = "flickity-page-dot", i.setAttribute("aria-label", `View slide ${n}`), i
        }));
        this.holder.append(...e), this.dots = this.dots.concat(e)
    }, i.prototype.removeDots = function(t) {
        this.dots.splice(this.dots.length - t, t).forEach((t => t.remove()))
    }, i.prototype.updateSelected = function(t) {
        this.selectedDot && (this.selectedDot.classList.remove("is-selected"), this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[t], this.selectedDot.classList.add("is-selected"), this.selectedDot.setAttribute("aria-current", "step"))
    }, t.PageDots = i, Object.assign(t.defaults, {
        pageDots: !0
    }), t.create.pageDots = function() {
        this.options.pageDots && (this.pageDots = new i, this.handlePageDotsClick = this.onPageDotsClick.bind(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
    };
    let n = t.prototype;
    return n.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length), this.focusableElems.push(...this.pageDots.dots), this.pageDots.holder.addEventListener("click", this.handlePageDotsClick), this.element.append(this.pageDots.holder)
    }, n.onPageDotsClick = function(t) {
        let e = this.pageDots.dots.indexOf(t.target); - 1 !== e && (this.uiChange(), this.select(e))
    }, n.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex)
    }, n.updatePageDots = function() {
        this.pageDots.dots.forEach((t => {
            e.removeFrom(this.focusableElems, t)
        })), this.pageDots.setDots(this.slides.length), this.focusableElems.push(...this.pageDots.dots)
    }, n.deactivatePageDots = function() {
        this.pageDots.holder.remove(), this.pageDots.holder.removeEventListener("click", this.handlePageDotsClick)
    }, t.PageDots = i, t
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(require("./core")) : e(t.Flickity)
}("undefined" != typeof window ? window : this, (function(t) {
    function e(t, e) {
        this.autoPlay = t, this.onTick = e, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
    }
    e.prototype.play = function() {
        "playing" !== this.state && (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : (this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()))
    }, e.prototype.tick = function() {
        if ("playing" !== this.state) return;
        let t = "number" == typeof this.autoPlay ? this.autoPlay : 3e3;
        this.clear(), this.timeout = setTimeout((() => {
            this.onTick(), this.tick()
        }), t)
    }, e.prototype.stop = function() {
        this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
    }, e.prototype.clear = function() {
        clearTimeout(this.timeout)
    }, e.prototype.pause = function() {
        "playing" === this.state && (this.state = "paused", this.clear())
    }, e.prototype.unpause = function() {
        "paused" === this.state && this.play()
    }, e.prototype.visibilityChange = function() {
        this[document.hidden ? "pause" : "unpause"]()
    }, e.prototype.visibilityPlay = function() {
        this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
    }, Object.assign(t.defaults, {
        pauseAutoPlayOnHover: !0
    }), t.create.player = function() {
        this.player = new e(this.options.autoPlay, (() => {
            this.next(!0)
        })), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
    };
    let i = t.prototype;
    return i.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
    }, i.playPlayer = function() {
        this.player.play()
    }, i.stopPlayer = function() {
        this.player.stop()
    }, i.pausePlayer = function() {
        this.player.pause()
    }, i.unpausePlayer = function() {
        this.player.unpause()
    }, i.deactivatePlayer = function() {
        this.player.stop(), this.element.removeEventListener("mouseenter", this)
    }, i.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
    }, i.onmouseleave = function() {
        this.player.unpause(), this.element.removeEventListener("mouseleave", this)
    }, t.Player = e, t
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(require("./core"), require("fizzy-ui-utils")) : e(t.Flickity, t.fizzyUIUtils)
}("undefined" != typeof window ? window : this, (function(t, e) {
    let i = t.prototype;
    return i.insert = function(t, e) {
        let i = this._makeCells(t);
        if (!i || !i.length) return;
        let n = this.cells.length;
        e = void 0 === e ? n : e;
        let s = function(t) {
                let e = document.createDocumentFragment();
                return t.forEach((t => e.appendChild(t.element))), e
            }(i),
            o = e === n;
        if (o) this.slider.appendChild(s);
        else {
            let t = this.cells[e].element;
            this.slider.insertBefore(s, t)
        }
        if (0 === e) this.cells = i.concat(this.cells);
        else if (o) this.cells = this.cells.concat(i);
        else {
            let t = this.cells.splice(e, n - e);
            this.cells = this.cells.concat(i).concat(t)
        }
        this._sizeCells(i), this.cellChange(e), this.positionSliderAtSelected()
    }, i.append = function(t) {
        this.insert(t, this.cells.length)
    }, i.prepend = function(t) {
        this.insert(t, 0)
    }, i.remove = function(t) {
        let i = this.getCells(t);
        if (!i || !i.length) return;
        let n = this.cells.length - 1;
        i.forEach((t => {
            t.remove();
            let i = this.cells.indexOf(t);
            n = Math.min(i, n), e.removeFrom(this.cells, t)
        })), this.cellChange(n), this.positionSliderAtSelected()
    }, i.cellSizeChange = function(t) {
        let e = this.getCell(t);
        if (!e) return;
        e.getSize();
        let i = this.cells.indexOf(e);
        this.cellChange(i)
    }, i.cellChange = function(t) {
        let e = this.selectedElement;
        this._positionCells(t), this._updateWrapShiftCells(), this.setGallerySize();
        let i = this.getCell(e);
        i && (this.selectedIndex = this.getCellSlideIndex(i)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [t]), this.select(this.selectedIndex)
    }, t
})),
function(t, e) {
    "object" == typeof module && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : e(t.Flickity, t.fizzyUIUtils)
}("undefined" != typeof window ? window : this, (function(t, e) {
    t.create.fade = function() {
        this.fadeIndex = this.selectedIndex, this.prevSelectedIndex = this.selectedIndex, this.on("select", this.onSelectFade), this.on("dragEnd", this.onDragEndFade), this.on("settle", this.onSettleFade), this.on("activate", this.onActivateFade), this.on("deactivate", this.onDeactivateFade)
    };
    let i = t.prototype,
        n = i.updateSlides;
    i.updateSlides = function() {
        n.apply(this, arguments), this.options.fade && this.slides.forEach(((t, e) => {
            let i = t.target - t.x,
                n = t.cells[0].x;
            t.cells.forEach((t => {
                let e = t.x - n - i;
                this._renderCellPosition(t, e)
            }))
        }))
    }, i.onSelectFade = function() {
        this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1), this.prevSelectedIndex = this.selectedIndex
    }, i.onSettleFade = function() {
        delete this.didDragEnd, this.options.fade
    }, i.onDragEndFade = function() {
        this.didDragEnd = !0
    }, i.onActivateFade = function() {
        this.options.fade && this.element.classList.add("is-fade")
    }, i.onDeactivateFade = function() {
        this.options.fade && this.element.classList.remove("is-fade")
    };
    let s = i.positionSlider;
    i.positionSlider = function() {
        this.options.fade ? (this.fadeSlides(), this.dispatchScrollEvent()) : s.apply(this, arguments)
    };
    let o = i.positionSliderAtSelected;
    i.positionSliderAtSelected = function() {
        this.options.fade && this.setTranslateX(0), o.apply(this, arguments)
    }, i.fadeSlides = function() {
        if (this.slides.length < 2) return;
        let t = this.getFadeIndexes(),
            e = this.slides[t.a],
            i = this.slides[t.b],
            n = this.wrapDifference(e.target, i.target),
            s = this.wrapDifference(e.target, -this.x);
        s /= n;
        let o = t.a;
        this.isDragging && (o = s > .5 ? t.a : t.b), void 0 !== this.fadeHideIndex && this.fadeHideIndex !== o && this.fadeHideIndex !== t.a && (this.fadeHideIndex, t.b), this.fadeHideIndex = o
    }, i.getFadeIndexes = function() {
        return this.isDragging || this.didDragEnd ? this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes() : {
            a: this.fadeIndex,
            b: this.selectedIndex
        }
    }, i.getFadeDragWrapIndexes = function() {
        let t = this.slides.map((function(t, e) {
                return this.getSlideDistance(-this.x, e)
            }), this),
            i = t.map((function(t) {
                return Math.abs(t)
            })),
            n = Math.min(...i),
            s = i.indexOf(n),
            o = t[s],
            r = this.slides.length,
            l = o >= 0 ? 1 : -1;
        return {
            a: s,
            b: e.modulo(s + l, r)
        }
    }, i.getFadeDragLimitIndexes = function() {
        let t = 0;
        for (let e = 0; e < this.slides.length - 1; e++) {
            let i = this.slides[e];
            if (-this.x < i.target) break;
            t = e
        }
        return {
            a: t,
            b: t + 1
        }
    }, i.wrapDifference = function(t, e) {
        let i = e - t;
        if (!this.options.wrapAround) return i;
        let n = i + this.slideableWidth,
            s = i - this.slideableWidth;
        return Math.abs(n) < Math.abs(i) && (i = n), Math.abs(s) < Math.abs(i) && (i = s), i
    };
    let r = i._updateWrapShiftCells;
    i._updateWrapShiftCells = function() {
        this.options.fade ? this.isWrapping = this.getIsWrapping() : r.apply(this, arguments)
    };
    let l = i.shiftWrapCells;
    return i.shiftWrapCells = function() {
        this.options.fade || l.apply(this, arguments)
    }, t
})),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).SplitType = e()
}(this, (function() {
    "use strict";

    function t(t, e) {
        return Object.getOwnPropertyNames(Object(t)).reduce(((i, n) => {
            const s = Object.getOwnPropertyDescriptor(Object(t), n),
                o = Object.getOwnPropertyDescriptor(Object(e), n);
            return Object.defineProperty(i, n, o || s)
        }), {})
    }

    function e(t) {
        return "string" == typeof t
    }

    function i(t) {
        return Array.isArray(t)
    }

    function n(n = {}) {
        const s = t(n);
        let o;
        return void 0 !== s.types ? o = s.types : void 0 !== s.split && (o = s.split), void 0 !== o && (s.types = (e(o) || i(o) ? String(o) : "").split(",").map((t => String(t).trim())).filter((t => /((line)|(word)|(char))/i.test(t)))), (s.absolute || s.position) && (s.absolute = s.absolute || /absolute/.test(n.position)), s
    }

    function s(t) {
        const n = e(t) || i(t) ? String(t) : "";
        return {
            none: !n,
            lines: /line/i.test(n),
            words: /word/i.test(n),
            chars: /char/i.test(n)
        }
    }

    function o(t) {
        return null !== t && "object" == typeof t
    }

    function r(t) {
        return o(t) && /^(1|3|11)$/.test(t.nodeType)
    }

    function l(t) {
        return i(t) ? t : null == t ? [] : function(t) {
            return o(t) && function(t) {
                return "number" == typeof t && t > -1 && t % 1 == 0
            }(t.length)
        }(t) ? Array.prototype.slice.call(t) : [t]
    }

    function a(t) {
        let i = t;
        return e(t) && (i = /^(#[a-z]\w+)$/.test(t.trim()) ? document.getElementById(t.trim().slice(1)) : document.querySelectorAll(t)), l(i).reduce(((t, e) => [...t, ...l(e).filter(r)]), [])
    }(() => {
        function t(...t) {
            const e = t.length;
            for (let i = 0; i < e; i++) {
                const e = t[i];
                1 === e.nodeType || 11 === e.nodeType ? this.appendChild(e) : this.appendChild(document.createTextNode(String(e)))
            }
        }

        function e(...t) {
            for (; this.lastChild;) this.removeChild(this.lastChild);
            t.length && this.append(...t)
        }

        function i(...t) {
            const e = this.parentNode;
            let i = t.length;
            if (e)
                for (i || e.removeChild(this); i--;) {
                    let n = t[i];
                    "object" != typeof n ? n = this.ownerDocument.createTextNode(n) : n.parentNode && n.parentNode.removeChild(n), i ? e.insertBefore(this.previousSibling, n) : e.replaceChild(n, this)
                }
        }
        "undefined" != typeof Element && (Element.prototype.append || (Element.prototype.append = t, DocumentFragment.prototype.append = t), Element.prototype.replaceChildren || (Element.prototype.replaceChildren = e, DocumentFragment.prototype.replaceChildren = e), Element.prototype.replaceWith || (Element.prototype.replaceWith = i, DocumentFragment.prototype.replaceWith = i))
    })();
    const {
        entries: h,
        keys: c,
        values: d
    } = Object, u = "_splittype", p = {};
    let f = 0;

    function g(t, e, i) {
        if (!o(t)) return console.warn("[data.set] owner is not an object"), null;
        const n = t[u] || (t[u] = ++f),
            s = p[n] || (p[n] = {});
        return void 0 === i ? e && Object.getPrototypeOf(e) === Object.prototype && (p[n] = {
            ...s,
            ...e
        }) : void 0 !== e && (s[e] = i), i
    }

    function m(t, e) {
        const i = o(t) ? t[u] : null,
            n = i && p[i] || {};
        return void 0 === e ? n : n[e]
    }

    function y(t) {
        const e = t && t[u];
        e && (delete t[e], delete p[e])
    }
    const v = "\\u0300-\\u036f\\ufe20-\\ufe23",
        w = `[${v}\\u20d0-\\u20f0]`,
        b = "\\ud83c[\\udffb-\\udfff]",
        S = "[^\\ud800-\\udfff]",
        E = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        x = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        C = `(?:${w}|${b})?`,
        D = "[\\ufe0e\\ufe0f]?",
        A = D + C + "(?:\\u200d(?:" + [S, E, x].join("|") + ")" + D + C + ")*",
        P = `(?:${[`${S}${w}?`,w,E,x,"[\\ud800-\\udfff]"].join("|")}\n)`,
        L = RegExp(`${b}(?=${b})|${P}${A}`, "g"),
        M = RegExp(`[${["\\u200d","\\ud800-\\udfff",v,"\\u20d0-\\u20f0","\\ufe0e\\ufe0f"].join("")}]`);

    function I(t) {
        return M.test(t)
    }

    function z(t, i = "") {
        var n;
        return (t = null == (n = t) ? "" : String(n)) && e(t) && !i && I(t) ? function(t) {
            return I(t) ? function(t) {
                return t.match(L) || []
            }(t) : function(t) {
                return t.split("")
            }(t)
        }(t) : t.split(i)
    }

    function k(t, i) {
        const n = document.createElement(t);
        return i ? (Object.keys(i).forEach((t => {
            const s = i[t],
                o = e(s) ? s.trim() : s;
            null !== o && "" !== o && ("children" === t ? n.append(...l(o)) : n.setAttribute(t, o))
        })), n) : n
    }
    var T = {
        splitClass: "",
        lineClass: "line",
        wordClass: "word",
        charClass: "char",
        types: ["lines", "words", "chars"],
        absolute: !1,
        tagName: "div"
    };

    function W(e, i) {
        const n = s((i = t(T, i)).types),
            o = i.tagName,
            r = e.nodeValue,
            l = document.createDocumentFragment();
        let a = [],
            h = [];
        return /^\s/.test(r) && l.append(" "), a = function(t, e = " ") {
            return (t ? String(t) : "").trim().replace(/\s+/g, " ").split(e)
        }(r).reduce(((t, e, s, r) => {
            let a, c;
            return n.chars && (c = z(e).map((t => {
                const e = k(o, {
                    class: `${i.splitClass} ${i.charClass}`,
                    style: "display: inline-block;",
                    children: t
                });
                return g(e, "isChar", !0), h = [...h, e], e
            }))), n.words || n.lines ? (a = k(o, {
                class: `${i.wordClass} ${i.splitClass}`,
                style: "display: inline-block; " + (n.words && i.absolute ? "position: relative;" : ""),
                children: n.chars ? c : e
            }), g(a, {
                isWord: !0,
                isWordStart: !0,
                isWordEnd: !0
            }), l.appendChild(a)) : c.forEach((t => {
                l.appendChild(t)
            })), s < r.length - 1 && l.append(" "), n.words ? t.concat(a) : t
        }), []), /\s$/.test(r) && l.append(" "), e.replaceWith(l), {
            words: a,
            chars: h
        }
    }

    function O(t, e) {
        const i = t.nodeType,
            n = {
                words: [],
                chars: []
            };
        if (!/(1|3|11)/.test(i)) return n;
        if (3 === i && /\S/.test(t.nodeValue)) return W(t, e);
        const s = l(t.childNodes);
        if (s.length && (g(t, "isSplit", !0), !m(t).isRoot)) {
            t.style.display = "inline-block", t.style.position = "relative";
            const e = t.nextSibling,
                i = t.previousSibling,
                n = t.textContent || "",
                s = e ? e.textContent : " ",
                o = i ? i.textContent : " ";
            g(t, {
                isWordEnd: /\s$/.test(n) || /^\s/.test(s),
                isWordStart: /^\s/.test(n) || /\s$/.test(o)
            })
        }
        return s.reduce(((t, i) => {
            const {
                words: n,
                chars: s
            } = O(i, e);
            return {
                words: [...t.words, ...n],
                chars: [...t.chars, ...s]
            }
        }), n)
    }

    function F(t) {
        m(t).isWord ? (y(t), t.replaceWith(...t.childNodes)) : l(t.children).forEach((t => F(t)))
    }
    let _ = t(T, {});
    class N {
        static get data() {
            return p
        }
        static get defaults() {
            return _
        }
        static set defaults(e) {
            _ = t(_, n(e))
        }
        static setDefaults(e) {
            return _ = t(_, n(e)), T
        }
        static revert(t) {
            a(t).forEach((t => {
                const {
                    isSplit: e,
                    html: i,
                    cssWidth: n,
                    cssHeight: s
                } = m(t);
                e && (t.innerHTML = i, t.style.width = n || "", t.style.height = s || "", y(t))
            }))
        }
        static create(t, e) {
            return new N(t, e)
        }
        constructor(e, i) {
            this.isSplit = !1, this.settings = t(_, n(i)), this.elements = a(e), this.split()
        }
        split(e) {
            this.revert(), this.elements.forEach((t => {
                g(t, "html", t.innerHTML)
            })), this.lines = [], this.words = [], this.chars = [];
            const i = [window.pageXOffset, window.pageYOffset];
            void 0 !== e && (this.settings = t(this.settings, n(e)));
            const o = s(this.settings.types);
            o.none || (this.elements.forEach((t => {
                g(t, "isRoot", !0);
                const {
                    words: e,
                    chars: i
                } = O(t, this.settings);
                this.words = [...this.words, ...e], this.chars = [...this.chars, ...i]
            })), this.elements.forEach((t => {
                if (o.lines || this.settings.absolute) {
                    const e = function(t, e, i) {
                        const n = s(e.types),
                            o = e.tagName,
                            r = t.getElementsByTagName("*"),
                            a = [];
                        let h, c, d, u = [],
                            p = null,
                            f = [];
                        const y = t.parentElement,
                            v = t.nextElementSibling,
                            w = document.createDocumentFragment(),
                            b = window.getComputedStyle(t),
                            S = b.textAlign,
                            E = .2 * parseFloat(b.fontSize);
                        return e.absolute && (d = {
                            left: t.offsetLeft,
                            top: t.offsetTop,
                            width: t.offsetWidth
                        }, c = t.offsetWidth, h = t.offsetHeight, g(t, {
                            cssWidth: t.style.width,
                            cssHeight: t.style.height
                        })), l(r).forEach((s => {
                            const o = s.parentElement === t,
                                {
                                    width: r,
                                    height: l,
                                    top: h,
                                    left: c
                                } = function(t, e, i, n) {
                                    if (!i.absolute) return {
                                        top: e ? t.offsetTop : null
                                    };
                                    const s = t.offsetParent,
                                        [o, r] = n;
                                    let l = 0,
                                        a = 0;
                                    if (s && s !== document.body) {
                                        const t = s.getBoundingClientRect();
                                        l = t.x + o, a = t.y + r
                                    }
                                    const {
                                        width: h,
                                        height: c,
                                        x: d,
                                        y: u
                                    } = t.getBoundingClientRect();
                                    return {
                                        width: h,
                                        height: c,
                                        top: u + r - a,
                                        left: d + o - l
                                    }
                                }(s, o, e, i);
                            /^br$/i.test(s.nodeName) || (n.lines && o && ((null === p || h - p >= E) && (p = h, a.push(u = [])), u.push(s)), e.absolute && g(s, {
                                top: h,
                                left: c,
                                width: r,
                                height: l
                            }))
                        })), y && y.removeChild(t), n.lines && (f = a.map((t => {
                            const i = k(o, {
                                class: `${e.splitClass} ${e.lineClass}`,
                                style: `display: block; text-align: ${S}; width: 100%;`
                            });
                            g(i, "isLine", !0);
                            const n = {
                                height: 0,
                                top: 1e4
                            };
                            return w.appendChild(i), t.forEach(((t, e, s) => {
                                const {
                                    isWordEnd: o,
                                    top: r,
                                    height: l
                                } = m(t), a = s[e + 1];
                                n.height = Math.max(n.height, l), n.top = Math.min(n.top, r), i.appendChild(t), o && m(a).isWordStart && i.append(" ")
                            })), e.absolute && g(i, {
                                height: n.height,
                                top: n.top
                            }), i
                        })), n.words || F(w), t.replaceChildren(w)), e.absolute && (t.style.width = (t.style.width || c) + "px", t.style.height = h + "px", l(r).forEach((t => {
                            const {
                                isLine: e,
                                top: i,
                                left: n,
                                width: s,
                                height: o
                            } = m(t), r = m(t.parentElement), l = !e && r.isLine;
                            t.style.top = (l ? i - r.top : i) + "px", t.style.left = e ? d.left + "px" : n - (l ? d.left : 0) + "px", t.style.height = o + "px", t.style.width = e ? d.width + "px" : s + "px", t.style.position = "absolute"
                        }))), y && (v ? y.insertBefore(t, v) : y.appendChild(t)), f
                    }(t, this.settings, i);
                    this.lines = [...this.lines, ...e]
                }
            })), this.isSplit = !0, window.scrollTo(i[0], i[1]), h(p).forEach((([t, {
                isRoot: e,
                isSplit: i
            }]) => {
                e && i || (p[t] = null, delete p[t])
            })))
        }
        revert() {
            this.isSplit && (this.lines = null, this.words = null, this.chars = null, this.isSplit = !1), N.revert(this.elements)
        }
    }
    return N
})),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).PhotoSwipeLightbox = e()
}(this, (function() {
    "use strict";

    function t(t, e, i) {
        const n = document.createElement(e);
        return t && (n.className = t), i && i.appendChild(n), n
    }

    function e(t, e, i) {
        t.style.width = "number" == typeof e ? `${e}px` : e, t.style.height = "number" == typeof i ? `${i}px` : i
    }
    const i = "loading",
        n = "loaded",
        s = "error";

    function o(t, e, i = document) {
        let n = [];
        if (t instanceof Element) n = [t];
        else if (t instanceof NodeList || Array.isArray(t)) n = Array.from(t);
        else {
            const s = "string" == typeof t ? t : e;
            s && (n = Array.from(i.querySelectorAll(s)))
        }
        return n
    }

    function r() {
        return !(!navigator.vendor || !navigator.vendor.match(/apple/i))
    }
    class l {
        constructor(t, e) {
            this.type = t, this.defaultPrevented = !1, e && Object.assign(this, e)
        }
        preventDefault() {
            this.defaultPrevented = !0
        }
    }
    class a {
        constructor(e, i) {
            if (this.element = t("pswp__img pswp__img--placeholder", e ? "img" : "div", i), e) {
                const t = this.element;
                t.decoding = "async", t.alt = "", t.src = e, t.setAttribute("role", "presentation")
            }
            this.element.setAttribute("aria-hidden", "true")
        }
        setDisplayedSize(t, i) {
            this.element && ("IMG" === this.element.tagName ? (e(this.element, 250, "auto"), this.element.style.transformOrigin = "0 0", this.element.style.transform = function(t, e, i) {
                let n = "translate3d(0px,0px,0)";
                return void 0 !== i && (n += ` scale3d(${i},${i},1)`), n
            }(0, 0, t / 250)) : e(this.element, t, i))
        }
        destroy() {
            this.element?.parentNode && this.element.remove(), this.element = null
        }
    }
    class h {
        constructor(t, e, i) {
            this.instance = e, this.data = t, this.index = i, this.element = void 0, this.placeholder = void 0, this.slide = void 0, this.displayedImageWidth = 0, this.displayedImageHeight = 0, this.width = Number(this.data.w) || Number(this.data.width) || 0, this.height = Number(this.data.h) || Number(this.data.height) || 0, this.isAttached = !1, this.hasSlide = !1, this.isDecoding = !1, this.state = "idle", this.data.type ? this.type = this.data.type : this.data.src ? this.type = "image" : this.type = "html", this.instance.dispatch("contentInit", {
                content: this
            })
        }
        removePlaceholder() {
            this.placeholder && !this.keepPlaceholder() && setTimeout((() => {
                this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0)
            }), 1e3)
        }
        load(e, i) {
            if (this.slide && this.usePlaceholder())
                if (this.placeholder) {
                    const t = this.placeholder.element;
                    t && !t.parentElement && this.slide.container.prepend(t)
                } else {
                    const t = this.instance.applyFilters("placeholderSrc", !(!this.data.msrc || !this.slide.isFirstSlide) && this.data.msrc, this);
                    this.placeholder = new a(t, this.slide.container)
                } this.element && !i || this.instance.dispatch("contentLoad", {
                content: this,
                isLazy: e
            }).defaultPrevented || (this.isImageContent() ? (this.element = t("pswp__img", "img"), this.displayedImageWidth && this.loadImage(e)) : (this.element = t("pswp__content", "div"), this.element.innerHTML = this.data.html || ""), i && this.slide && this.slide.updateContentSize(!0))
        }
        loadImage(t) {
            if (!this.isImageContent() || !this.element || this.instance.dispatch("contentLoadImage", {
                    content: this,
                    isLazy: t
                }).defaultPrevented) return;
            const e = this.element;
            this.updateSrcsetSizes(), this.data.srcset && (e.srcset = this.data.srcset), e.src = this.data.src ?? "", e.alt = this.data.alt ?? "", this.state = i, e.complete ? this.onLoaded() : (e.onload = () => {
                this.onLoaded()
            }, e.onerror = () => {
                this.onError()
            })
        }
        setSlide(t) {
            this.slide = t, this.hasSlide = !0, this.instance = t.pswp
        }
        onLoaded() {
            this.state = n, this.slide && this.element && (this.instance.dispatch("loadComplete", {
                slide: this.slide,
                content: this
            }), this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode && (this.append(), this.slide.updateContentSize(!0)), this.state !== n && this.state !== s || this.removePlaceholder())
        }
        onError() {
            this.state = s, this.slide && (this.displayError(), this.instance.dispatch("loadComplete", {
                slide: this.slide,
                isError: !0,
                content: this
            }), this.instance.dispatch("loadError", {
                slide: this.slide,
                content: this
            }))
        }
        isLoading() {
            return this.instance.applyFilters("isContentLoading", this.state === i, this)
        }
        isError() {
            return this.state === s
        }
        isImageContent() {
            return "image" === this.type
        }
        setDisplayedSize(t, i) {
            if (this.element && (this.placeholder && this.placeholder.setDisplayedSize(t, i), !this.instance.dispatch("contentResize", {
                    content: this,
                    width: t,
                    height: i
                }).defaultPrevented && (e(this.element, t, i), this.isImageContent() && !this.isError()))) {
                const e = !this.displayedImageWidth && t;
                this.displayedImageWidth = t, this.displayedImageHeight = i, e ? this.loadImage(!1) : this.updateSrcsetSizes(), this.slide && this.instance.dispatch("imageSizeChange", {
                    slide: this.slide,
                    width: t,
                    height: i,
                    content: this
                })
            }
        }
        isZoomable() {
            return this.instance.applyFilters("isContentZoomable", this.isImageContent() && this.state !== s, this)
        }
        updateSrcsetSizes() {
            if (!this.isImageContent() || !this.element || !this.data.srcset) return;
            const t = this.element,
                e = this.instance.applyFilters("srcsetSizesWidth", this.displayedImageWidth, this);
            (!t.dataset.largestUsedSize || e > parseInt(t.dataset.largestUsedSize, 10)) && (t.sizes = e + "px", t.dataset.largestUsedSize = String(e))
        }
        usePlaceholder() {
            return this.instance.applyFilters("useContentPlaceholder", this.isImageContent(), this)
        }
        lazyLoad() {
            this.instance.dispatch("contentLazyLoad", {
                content: this
            }).defaultPrevented || this.load(!0)
        }
        keepPlaceholder() {
            return this.instance.applyFilters("isKeepingPlaceholder", this.isLoading(), this)
        }
        destroy() {
            this.hasSlide = !1, this.slide = void 0, this.instance.dispatch("contentDestroy", {
                content: this
            }).defaultPrevented || (this.remove(), this.placeholder && (this.placeholder.destroy(), this.placeholder = void 0), this.isImageContent() && this.element && (this.element.onload = null, this.element.onerror = null, this.element = void 0))
        }
        displayError() {
            if (this.slide) {
                let e = t("pswp__error-msg", "div");
                e.innerText = this.instance.options?.errorMsg ?? "", e = this.instance.applyFilters("contentErrorElement", e, this), this.element = t("pswp__content pswp__error-msg-container", "div"), this.element.appendChild(e), this.slide.container.innerText = "", this.slide.container.appendChild(this.element), this.slide.updateContentSize(!0), this.removePlaceholder()
            }
        }
        append() {
            if (this.isAttached || !this.element) return;
            if (this.isAttached = !0, this.state === s) return void this.displayError();
            if (this.instance.dispatch("contentAppend", {
                    content: this
                }).defaultPrevented) return;
            const t = "decode" in this.element;
            this.isImageContent() ? t && this.slide && (!this.slide.isActive || r()) ? (this.isDecoding = !0, this.element.decode().catch((() => {})).finally((() => {
                this.isDecoding = !1, this.appendImage()
            }))) : this.appendImage() : this.slide && !this.element.parentNode && this.slide.container.appendChild(this.element)
        }
        activate() {
            !this.instance.dispatch("contentActivate", {
                content: this
            }).defaultPrevented && this.slide && (this.isImageContent() && this.isDecoding && !r() ? this.appendImage() : this.isError() && this.load(!1, !0), this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "false"))
        }
        deactivate() {
            this.instance.dispatch("contentDeactivate", {
                content: this
            }), this.slide && this.slide.holderElement && this.slide.holderElement.setAttribute("aria-hidden", "true")
        }
        remove() {
            this.isAttached = !1, this.instance.dispatch("contentRemove", {
                content: this
            }).defaultPrevented || (this.element && this.element.parentNode && this.element.remove(), this.placeholder && this.placeholder.element && this.placeholder.element.remove())
        }
        appendImage() {
            this.isAttached && (this.instance.dispatch("contentAppendImage", {
                content: this
            }).defaultPrevented || (this.slide && this.element && !this.element.parentNode && this.slide.container.appendChild(this.element), this.state !== n && this.state !== s || this.removePlaceholder()))
        }
    }

    function c(t, e, i, n, s) {
        let o = 0;
        if (e.paddingFn) o = e.paddingFn(i, n, s)[t];
        else if (e.padding) o = e.padding[t];
        else {
            const i = "padding" + t[0].toUpperCase() + t.slice(1);
            e[i] && (o = e[i])
        }
        return Number(o) || 0
    }
    class d {
        constructor(t, e, i, n) {
            this.pswp = n, this.options = t, this.itemData = e, this.index = i, this.panAreaSize = null, this.elementSize = null, this.fit = 1, this.fill = 1, this.vFill = 1, this.initial = 1, this.secondary = 1, this.max = 1, this.min = 1
        }
        update(t, e, i) {
            const n = {
                x: t,
                y: e
            };
            this.elementSize = n, this.panAreaSize = i;
            const s = i.x / n.x,
                o = i.y / n.y;
            this.fit = Math.min(1, s < o ? s : o), this.fill = Math.min(1, s > o ? s : o), this.vFill = Math.min(1, o), this.initial = this.t(), this.secondary = this.i(), this.max = Math.max(this.initial, this.secondary, this.o()), this.min = Math.min(this.fit, this.initial, this.secondary), this.pswp && this.pswp.dispatch("zoomLevelsUpdate", {
                zoomLevels: this,
                slideData: this.itemData
            })
        }
        l(t) {
            const e = t + "ZoomLevel",
                i = this.options[e];
            if (i) return "function" == typeof i ? i(this) : "fill" === i ? this.fill : "fit" === i ? this.fit : Number(i)
        }
        i() {
            let t = this.l("secondary");
            return t || (t = Math.min(1, 3 * this.fit), this.elementSize && t * this.elementSize.x > 4e3 && (t = 4e3 / this.elementSize.x), t)
        }
        t() {
            return this.l("initial") || this.fit
        }
        o() {
            return this.l("max") || Math.max(1, 4 * this.fit)
        }
    }

    function u(t, e, i) {
        const n = e.createContentFromData(t, i);
        let s;
        const {
            options: o
        } = e;
        if (o) {
            let r;
            s = new d(o, t, -1), r = e.pswp ? e.pswp.viewportSize : function(t, e) {
                if (t.getViewportSizeFn) {
                    const i = t.getViewportSizeFn(t, e);
                    if (i) return i
                }
                return {
                    x: document.documentElement.clientWidth,
                    y: window.innerHeight
                }
            }(o, e);
            const l = function(t, e, i, n) {
                return {
                    x: e.x - c("left", t, e, i, n) - c("right", t, e, i, n),
                    y: e.y - c("top", t, e, i, n) - c("bottom", t, e, i, n)
                }
            }(o, r, t, i);
            s.update(n.width, n.height, l)
        }
        return n.lazyLoad(), s && n.setDisplayedSize(Math.ceil(n.width * s.initial), Math.ceil(n.height * s.initial)), n
    }
    return class extends class extends class {
        constructor() {
            this.u = {}, this.p = {}, this.pswp = void 0, this.options = void 0
        }
        addFilter(t, e, i = 100) {
            this.p[t] || (this.p[t] = []), this.p[t]?.push({
                fn: e,
                priority: i
            }), this.p[t]?.sort(((t, e) => t.priority - e.priority)), this.pswp?.addFilter(t, e, i)
        }
        removeFilter(t, e) {
            this.p[t] && (this.p[t] = this.p[t].filter((t => t.fn !== e))), this.pswp && this.pswp.removeFilter(t, e)
        }
        applyFilters(t, ...e) {
            return this.p[t]?.forEach((t => {
                e[0] = t.fn.apply(this, e)
            })), e[0]
        }
        on(t, e) {
            this.u[t] || (this.u[t] = []), this.u[t]?.push(e), this.pswp?.on(t, e)
        }
        off(t, e) {
            this.u[t] && (this.u[t] = this.u[t].filter((t => e !== t))), this.pswp?.off(t, e)
        }
        dispatch(t, e) {
            if (this.pswp) return this.pswp.dispatch(t, e);
            const i = new l(t, e);
            return this.u[t]?.forEach((t => {
                t.call(this, i)
            })), i
        }
    } {
        getNumItems() {
            let t = 0;
            const e = this.options?.dataSource;
            e && "length" in e ? t = e.length : e && "gallery" in e && (e.items || (e.items = this.m(e.gallery)), e.items && (t = e.items.length));
            const i = this.dispatch("numItems", {
                dataSource: e,
                numItems: t
            });
            return this.applyFilters("numItems", i.numItems, e)
        }
        createContentFromData(t, e) {
            return new h(t, this, e)
        }
        getItemData(t) {
            const e = this.options?.dataSource;
            let i = {};
            Array.isArray(e) ? i = e[t] : e && "gallery" in e && (e.items || (e.items = this.m(e.gallery)), i = e.items[t]);
            let n = i;
            n instanceof Element && (n = this.g(n));
            const s = this.dispatch("itemData", {
                itemData: n || {},
                index: t
            });
            return this.applyFilters("itemData", s.itemData, t)
        }
        m(t) {
            return this.options?.children || this.options?.childSelector ? o(this.options.children, this.options.childSelector, t) || [] : [t]
        }
        g(t) {
            const e = {
                    element: t
                },
                i = "A" === t.tagName ? t : t.querySelector("a");
            if (i) {
                e.src = i.dataset.pswpSrc || i.href, i.dataset.pswpSrcset && (e.srcset = i.dataset.pswpSrcset), e.width = i.dataset.pswpWidth ? parseInt(i.dataset.pswpWidth, 10) : 0, e.height = i.dataset.pswpHeight ? parseInt(i.dataset.pswpHeight, 10) : 0, e.w = e.width, e.h = e.height, i.dataset.pswpType && (e.type = i.dataset.pswpType);
                const n = t.querySelector("img");
                n && (e.msrc = n.currentSrc || n.src, e.alt = n.getAttribute("alt") ?? ""), (i.dataset.pswpCropped || i.dataset.cropped) && (e.thumbCropped = !0)
            }
            return this.applyFilters("domItemData", e, t, i)
        }
        lazyLoadData(t, e) {
            return u(t, this, e)
        }
    } {
        constructor(t) {
            super(), this.options = t || {}, this.v = 0, this.shouldOpen = !1, this._ = void 0, this.onThumbnailsClick = this.onThumbnailsClick.bind(this)
        }
        init() {
            o(this.options.gallery, this.options.gallerySelector).forEach((t => {
                t.addEventListener("click", this.onThumbnailsClick, !1)
            }))
        }
        onThumbnailsClick(t) {
            if (function(t) {
                    return "button" in t && 1 === t.button || t.ctrlKey || t.metaKey || t.altKey || t.shiftKey
                }(t) || window.pswp) return;
            let e = {
                x: t.clientX,
                y: t.clientY
            };
            e.x || e.y || (e = null);
            let i = this.getClickedIndex(t);
            i = this.applyFilters("clickedIndex", i, t, this);
            const n = {
                gallery: t.currentTarget
            };
            i >= 0 && (t.preventDefault(), this.loadAndOpen(i, n, e))
        }
        getClickedIndex(t) {
            if (this.options.getClickedIndexFn) return this.options.getClickedIndexFn.call(this, t);
            const e = t.target,
                i = o(this.options.children, this.options.childSelector, t.currentTarget).findIndex((t => t === e || t.contains(e)));
            return -1 !== i ? i : this.options.children || this.options.childSelector ? -1 : 0
        }
        loadAndOpen(t, e, i) {
            return !window.pswp && (this.options.index = t, this.options.initialPointerPos = i, this.shouldOpen = !0, this.preload(t, e), !0)
        }
        preload(t, e) {
            const {
                options: i
            } = this;
            e && (i.dataSource = e);
            const n = [],
                s = typeof i.pswpModule;
            if ("function" == typeof(o = i.pswpModule) && o.prototype && o.prototype.goTo) n.push(Promise.resolve(i.pswpModule));
            else {
                if ("string" === s) throw new Error("pswpModule as string is no longer supported");
                if ("function" !== s) throw new Error("pswpModule is not valid");
                n.push(i.pswpModule())
            }
            var o;
            "function" == typeof i.openPromise && n.push(i.openPromise()), !1 !== i.preloadFirstSlide && t >= 0 && (this._ = function(t, e) {
                const i = e.getItemData(t);
                if (!e.dispatch("lazyLoadSlide", {
                        index: t,
                        itemData: i
                    }).defaultPrevented) return u(i, e, t)
            }(t, this));
            const r = ++this.v;
            Promise.all(n).then((t => {
                if (this.shouldOpen) {
                    const e = t[0];
                    this.I(e, r)
                }
            }))
        }
        I(t, e) {
            if (e !== this.v && this.shouldOpen) return;
            if (this.shouldOpen = !1, window.pswp) return;
            const i = "object" == typeof t ? new t.default(this.options) : new t(this.options);
            this.pswp = i, window.pswp = i, Object.keys(this.u).forEach((t => {
                this.u[t]?.forEach((e => {
                    i.on(t, e)
                }))
            })), Object.keys(this.p).forEach((t => {
                this.p[t]?.forEach((e => {
                    i.addFilter(t, e.fn, e.priority)
                }))
            })), this._ && (i.contentLoader.addToCache(this._), this._ = void 0), i.on("destroy", (() => {
                this.pswp = void 0, delete window.pswp
            })), i.init()
        }
        destroy() {
            this.pswp?.destroy(), this.shouldOpen = !1, this.u = {}, o(this.options.gallery, this.options.gallerySelector).forEach((t => {
                t.removeEventListener("click", this.onThumbnailsClick, !1)
            }))
        }
    }
})),
function() {
    "use strict";

    function t(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var i = 0, n = Array(e); i < e; i++) n[i] = t[i];
        return n
    }

    function e(e, i) {
        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (!n) {
            if (Array.isArray(e) || (n = function(e, i) {
                    if (e) {
                        if ("string" == typeof e) return t(e, i);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? t(e, i) : void 0
                    }
                }(e)) || i && e && "number" == typeof e.length) {
                n && (e = n);
                var s = 0,
                    o = function() {};
                return {
                    s: o,
                    n: function() {
                        return s >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[s++]
                        }
                    },
                    e: function(t) {
                        throw t
                    },
                    f: o
                }
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }
        var r, l = !0,
            a = !1;
        return {
            s: function() {
                n = n.call(e)
            },
            n: function() {
                var t = n.next();
                return l = t.done, t
            },
            e: function(t) {
                a = !0, r = t
            },
            f: function() {
                try {
                    l || null == n.return || n.return()
                } finally {
                    if (a) throw r
                }
            }
        }
    }
    var i = function(t, e) {
            var i = function(t) {
                    for (var e = 0, i = t.length; e < i; e++) n(t[e])
                },
                n = function(t) {
                    var e = t.target,
                        i = t.attributeName,
                        n = t.oldValue;
                    e.attributeChangedCallback(i, n, e.getAttribute(i))
                };
            return function(s, o) {
                var r = s.constructor.observedAttributes;
                return r && t(o).then((function() {
                    new e(i).observe(s, {
                        attributes: !0,
                        attributeOldValue: !0,
                        attributeFilter: r
                    });
                    for (var t = 0, o = r.length; t < o; t++) s.hasAttribute(r[t]) && n({
                        target: s,
                        attributeName: r[t],
                        oldValue: null
                    })
                })), s
            }
        },
        n = !0,
        s = !1,
        o = "querySelectorAll",
        r = "querySelectorAll",
        l = self,
        a = l.document,
        h = l.Element,
        c = l.MutationObserver,
        d = l.Set,
        u = l.WeakMap,
        p = function(t) {
            return r in t
        },
        f = [].filter,
        g = function(t) {
            var i = new u,
                l = function(e, n) {
                    var s;
                    if (n)
                        for (var o, r = function(t) {
                                return t.matches || t.webkitMatchesSelector || t.msMatchesSelector
                            }(e), l = 0, a = m.length; l < a; l++) r.call(e, o = m[l]) && (i.has(e) || i.set(e, new d), (s = i.get(e)).has(o) || (s.add(o), t.handle(e, n, o)));
                    else i.has(e) && (s = i.get(e), i.delete(e), s.forEach((function(i) {
                        t.handle(e, n, i)
                    })))
                },
                g = function(t) {
                    for (var e = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1], i = 0, n = t.length; i < n; i++) l(t[i], e)
                },
                m = t.query,
                y = t.root || a,
                v = function(t) {
                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document,
                        r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : MutationObserver,
                        l = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : ["*"],
                        a = function i(s, r, l, a, h, c) {
                            var d, u = e(s);
                            try {
                                for (u.s(); !(d = u.n()).done;) {
                                    var p = d.value;
                                    (c || o in p) && (h ? l.has(p) || (l.add(p), a.delete(p), t(p, h)) : a.has(p) || (a.add(p), l.delete(p), t(p, h)), c || i(p[o](r), r, l, a, h, n))
                                }
                            } catch (t) {
                                u.e(t)
                            } finally {
                                u.f()
                            }
                        },
                        h = new r((function(t) {
                            if (l.length) {
                                var i, o = l.join(","),
                                    r = new Set,
                                    h = new Set,
                                    c = e(t);
                                try {
                                    for (c.s(); !(i = c.n()).done;) {
                                        var d = i.value,
                                            u = d.addedNodes,
                                            p = d.removedNodes;
                                        a(p, o, r, h, s, s), a(u, o, r, h, n, s)
                                    }
                                } catch (r) {
                                    c.e(r)
                                } finally {
                                    c.f()
                                }
                            }
                        })),
                        c = h.observe;
                    return (h.observe = function(t) {
                        return c.call(h, t, {
                            subtree: n,
                            childList: n
                        })
                    })(i), h
                }(l, y, c, m),
                w = h.prototype.attachShadow;
            return w && (h.prototype.attachShadow = function(t) {
                var e = w.call(this, t);
                return v.observe(e), e
            }), m.length && g(y[r](m)), {
                drop: function(t) {
                    for (var e = 0, n = t.length; e < n; e++) i.delete(t[e])
                },
                flush: function() {
                    for (var t = v.takeRecords(), e = 0, i = t.length; e < i; e++) g(f.call(t[e].removedNodes, p), !1), g(f.call(t[e].addedNodes, p), !0)
                },
                observer: v,
                parse: g
            }
        },
        m = self,
        y = m.document,
        v = m.Map,
        w = m.MutationObserver,
        b = m.Object,
        S = m.Set,
        E = m.WeakMap,
        x = m.Element,
        C = m.HTMLElement,
        D = m.Node,
        A = m.Error,
        P = m.TypeError,
        L = m.Reflect,
        M = b.defineProperty,
        I = b.keys,
        z = b.getOwnPropertyNames,
        k = b.setPrototypeOf,
        T = !self.customElements,
        W = function(t) {
            for (var e = I(t), i = [], n = new S, s = e.length, o = 0; o < s; o++) {
                i[o] = t[e[o]];
                try {
                    delete t[e[o]]
                } catch (t) {
                    n.add(o)
                }
            }
            return function() {
                for (var o = 0; o < s; o++) n.has(o) || (t[e[o]] = i[o])
            }
        };
    if (T) {
        var O = function() {
                var t = this.constructor;
                if (!_.has(t)) throw new P("Illegal constructor");
                var e = _.get(t);
                if (q) return U(q, e);
                var i = F.call(y, e);
                return U(k(i, t.prototype), e)
            },
            F = y.createElement,
            _ = new v,
            N = new v,
            j = new v,
            B = new v,
            $ = [],
            H = g({
                query: $,
                handle: function(t, e, i) {
                    var n = j.get(i);
                    if (e && !n.isPrototypeOf(t)) {
                        var s = W(t);
                        q = k(t, n);
                        try {
                            new n.constructor
                        } finally {
                            q = null, s()
                        }
                    }
                    var o = "".concat(e ? "" : "dis", "connectedCallback");
                    o in n && t[o]()
                }
            }).parse,
            q = null,
            R = function(t) {
                if (!N.has(t)) {
                    var e, i = new Promise((function(t) {
                        e = t
                    }));
                    N.set(t, {
                        $: i,
                        _: e
                    })
                }
                return N.get(t).$
            },
            U = i(R, w);
        self.customElements = {
            define: function(t, e) {
                if (B.has(t)) throw new A('the name "'.concat(t, '" has already been used with this registry'));
                _.set(e, t), j.set(t, e.prototype), B.set(t, e), $.push(t), R(t).then((function() {
                    H(y.querySelectorAll(t))
                })), N.get(t)._(e)
            },
            get: function(t) {
                return B.get(t)
            },
            whenDefined: R
        }, M(O.prototype = C.prototype, "constructor", {
            value: O
        }), self.HTMLElement = O, y.createElement = function(t, e) {
            var i = e && e.is,
                n = i ? B.get(i) : B.get(t);
            return n ? new n : F.call(y, t)
        }, "isConnected" in D.prototype || M(D.prototype, "isConnected", {
            configurable: !0,
            get: function() {
                return !(this.ownerDocument.compareDocumentPosition(this) & this.DOCUMENT_POSITION_DISCONNECTED)
            }
        })
    } else if (T = !self.customElements.get("extends-br")) try {
        var V = function t() {
            return self.Reflect.construct(HTMLBRElement, [], t)
        };
        V.prototype = HTMLLIElement.prototype, self.customElements.define("extends-br", V, {
            extends: "br"
        }), T = 0 > y.createElement("br", {
            is: "extends-br"
        }).outerHTML.indexOf("extends-br");
        var X = self.customElements,
            G = X.get,
            Y = X.whenDefined;
        self.customElements.whenDefined = function(t) {
            var e = this;
            return Y.call(this, t).then((function(i) {
                return i || G.call(e, t)
            }))
        }
    } catch (r) {}
    if (T) {
        var Z = function(t) {
                var e = st.get(t);
                pt(e.querySelectorAll(this), t.isConnected)
            },
            K = self.customElements,
            Q = y.createElement,
            J = K.define,
            tt = K.get,
            et = K.upgrade,
            it = L || {
                construct: function(t) {
                    return t.call(this)
                }
            },
            nt = it.construct,
            st = new E,
            ot = new S,
            rt = new v,
            lt = new v,
            at = new v,
            ht = new v,
            ct = [],
            dt = [],
            ut = function(t) {
                return ht.get(t) || tt.call(K, t)
            },
            pt = g({
                query: dt,
                handle: function(t, e, i) {
                    var n = at.get(i);
                    if (e && !n.isPrototypeOf(t)) {
                        var s = W(t);
                        vt = k(t, n);
                        try {
                            new n.constructor
                        } finally {
                            vt = null, s()
                        }
                    }
                    var o = "".concat(e ? "" : "dis", "connectedCallback");
                    o in n && t[o]()
                }
            }).parse,
            ft = g({
                query: ct,
                handle: function(t, e) {
                    st.has(t) && (e ? ot.add(t) : ot.delete(t), dt.length && Z.call(dt, t))
                }
            }).parse,
            gt = x.prototype.attachShadow;
        gt && (x.prototype.attachShadow = function(t) {
            var e = gt.call(this, t);
            return st.set(this, e), e
        });
        var mt = function(t) {
                if (!lt.has(t)) {
                    var e, i = new Promise((function(t) {
                        e = t
                    }));
                    lt.set(t, {
                        $: i,
                        _: e
                    })
                }
                return lt.get(t).$
            },
            yt = i(mt, w),
            vt = null;
        z(self).filter((function(t) {
            return /^HTML.*Element$/.test(t)
        })).forEach((function(t) {
            function e() {
                var t = this.constructor;
                if (!rt.has(t)) throw new P("Illegal constructor");
                var e = rt.get(t),
                    n = e.is,
                    s = e.tag;
                if (n) {
                    if (vt) return yt(vt, n);
                    var o = Q.call(y, s);
                    return o.setAttribute("is", n), yt(k(o, t.prototype), n)
                }
                return nt.call(this, i, [], t)
            }
            var i = self[t];
            M(e.prototype = i.prototype, "constructor", {
                value: e
            }), M(self, t, {
                value: e
            })
        })), y.createElement = function(t, e) {
            var i = e && e.is;
            if (i) {
                var n = ht.get(i);
                if (n && rt.get(n).tag === t) return new n
            }
            var s = Q.call(y, t);
            return i && s.setAttribute("is", i), s
        }, K.get = ut, K.whenDefined = mt, K.upgrade = function(t) {
            var e = t.getAttribute("is");
            if (e) {
                var i = ht.get(e);
                if (i) return void yt(k(t, i.prototype), e)
            }
            et.call(K, t)
        }, K.define = function(t, e, i) {
            if (ut(t)) throw new A("'".concat(t, "' has already been defined as a custom element"));
            var n, s = i && i.extends;
            rt.set(e, s ? {
                is: t,
                tag: s
            } : {
                is: "",
                tag: t
            }), s ? (n = "".concat(s, '[is="').concat(t, '"]'), at.set(n, e.prototype), ht.set(t, e), dt.push(n)) : (J.apply(K, arguments), ct.push(n = t)), mt(t).then((function() {
                s ? (pt(y.querySelectorAll(n)), ot.forEach(Z, [n])) : ft(y.querySelectorAll(n))
            })), lt.get(t)._(e)
        }
    }
}();
class LazyImage extends HTMLImageElement {
    constructor() {
        super()
    }
    connectedCallback() {
        if (null !== this.media) {
            window.addEventListener("resize", this.handleLazy.bind(this));
            new MutationObserver((t => {
                t.forEach((t => {
                    (t.attributeName.includes("src") || t.attributeName.includes("srcset")) && this.handleLazy()
                }))
            })).observe(this, {
                attributes: !0
            }), this.handleLazy()
        }
    }
    get media() {
        return this._media = this._media || this.closest(".media")
    }
    handleLazy() {
        this.complete || this.classList.contains("loaded") || (this.media.classList.add("loading"), this.addEventListener("load", (() => {
            const t = () => {
                this.classList.add("loaded"), this.media.classList.remove("loading")
            };
            window.requestIdleCallback ? window.requestIdleCallback(t, {
                timeout: 150
            }) : setTimeout(t)
        }), !1))
    }
}
customElements.define("lazy-image", LazyImage, {
    extends: "img"
});